import _ from "lodash";
import React, { createRef, useRef, useMemo, useCallback } from "react";
import classes from "./PostCard.scss";
import MediaPlaceholder from "UIComponents/MediaPlaceholder";
import TextMoreLessV2 from "UIComponents/TextMoreLessV2";
import I18nHOC from "UIComponents/I18nHOC";
import LinkWithTooltip from "UIComponents/LinkWithTooltip";
import MediaModal from "UIComponents/MediaModal";
import AudioWaveformPlayer from "UIComponents/AudioWaveformPlayer";
import { colors } from "Constants";
import { compose } from "lib/apolloClient";
import { connect } from "react-redux";
import { getTimeSince, scrollIntoView, onEnterOrSpaceKeyDown } from "Utils";
import {
  CommentRemarkOutlined,
  LockOutlined,
  StudentOutlined,
  FamilyOutlined,
  GlobeOutlined,
  CloseOutlined,
  PencilOutlined,
  DownloadOutlined,
} from "@toddle-edu/ds-icons";
import classNames from "classnames";
import {
  getSharedWithString,
  getSharedWithStringV2,
  isPostSeenByUser,
  hasTranslationPermission,
  fetchStudentActivitiesMemoized,
  fetchfilteredStudentActivities,
  isPortfolioParityEnabled,
  isPortfolioParityEnabledAndIsJournalRoute,
  getFormattedUserNameWithoutPronoun,
  isPortfolioReviewSetupEnabledAndIsJournalRoute,
  TRIGGER_EVENT_TYPES,
  isPortfolioRevampAndIsJournalRoute,
  canManagePortfolioActions,
  fetchStudentRoutinesMemoized,
  fetchfilteredStudentRoutines,
  getTaggedAssessment,
  getIsNewGoalTaggingEnabled,
  isAssessmentTagged,
} from "Post/utils";
import { useKeyDownWrapper } from "Post/hooks";
import { FooterButtons } from "../FooterButtons";
import DropDown from "../FooterButtons/DropDown";
import { CreateAssessmentSvg } from "SvgComponents";

// Journal revamp imports
import DualProfile from "../DualProfile";
import StudentResponseV2 from "AppComponents/Post/routes/CreatePost/components/Screens/StudentResponseV2";
import PostSharedWithModal from "../PostSharedWithModal";
import { Trans } from "react-i18next";
import {
  IconButton,
  MediaCard,
  Tooltip as DSTooltip,
} from "@toddle-edu/ds-web";
import { getSettingValue } from "modules/PermissionModule";
import {
  markPostAsSeenByUser,
  updatePostStatus,
} from "Journal/modules/JournalModule";
import ACLStore from "lib/aclStore";
import PostSeenLikeModal from "../PostSeenLikeModal";
import FooterText from "../FooterText";
import { showNewTheatreMode } from "Utils/GetTheatreModeType";
import TheatreModeV2 from "UIComponents/TheatreModeV2";
import PostDetail from "Post/routes/PostDetail";
import { getCourseDetailsFromCache } from "Teacher/routes/Courses/routes/Course/modules/CourseGraphqlHelpers";
import moment from "moment";
import CardCommentsV2 from "AppComponents/Post/components/CardComments/CardCommentsV2";
import { syncPostCommentsCache } from "Post/modules/PostGraphqlHelpers";
import { PostCommentFragment } from "Post/modules/PostFragments";
import StudentActivities from "../StudentActivities";
import StudentActivityDetail from "../StudentActivityDetail";
import { getStudentIdentifierName } from "Utils/GetFormattedStudentName";
import { getFormattedUserName } from "Utils/GetFormattedUserName";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import {
  getSelectedCurriculumId,
  getSelectedAcademicYearId,
  getDefaultStudentNameOrderPreference,
  getDefaultStudentIdentifierNamePreference,
} from "modules/CommonSelectors";
import withQueryParamsBasedInterface from "UIComponents/QueryParamsBasedInterfaceHOC";
import { getCurrentAssessmentTypes } from "Platform/modules/PlatformModule";
import { hasIncludeGivenPathInCurrentRoute } from "Teacher/routes/Courses/routes/Course/routes/UnitPlans/routes/UnitPlanDetails/routes/EditUnitPlan/routes/IBPlanner/modules/IBPlannerModule";
import TaggedFoldersV2 from "Post/components/TaggedFolders/TaggedFoldersV2";
import { downloadFromUrl, removeProgressElement } from "modules/Services";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import { ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION } from "Constants/permissionConstants";

import StudentRoutineDetails from "AppComponents/Routines/components/StudentRoutineDetails";
import {
  isRoutinesRoute,
  isRoutinesEnabled,
  canManageRoutineActions,
} from "AppComponents/Routines/utils";

const style = {
  largeCardContainerStyle: {
    outline: `solid 1px ${colors.strokeOne}`,
    boxShadow: "0px 1px 2px 0px #002E3926",
    padding: "32px",
  },
  smallCardContainerStyle: {
    border: "none",
    boxShadow: "none",
    padding: "16px",
    marginBottom: "16px",
  },
  containerStyle: {
    paddingBottom: "16px",
    borderWidth: 1,
    borderColor: colors.borderDefault,
    borderRadius: "16px",
    overflow: "hidden",
    display: "flex",
    justifyContent: "center",
  },
  horizontalCardStyle: {
    width: "192px",
  },
  responseStyle: {
    marginTop: "16px",
  },
  moreStyle: {
    color: colors.textDefault,
  },
  stickyCommentStyle: showNewTheatreMode => ({
    paddingBottom: showNewTheatreMode ? "112px" : "0px",
  }),
  mediaPlaceHolderContainerStyle: { marginBottom: "8px" },
  foldersSubDetailContainer: {
    paddingTop: "16px",
  },
  taggedCreatedByBottomContainerStyle: {
    justifyContent: "flex-end",
    flexDirection: "row-reverse",
  },
  cascadeProfileStyle: {
    zIndex: "0",
    marginTop: "-32px",
  },
  approvalContainerStyle: { marginTop: "-16px" },
};

const BLANK_ARRAY = [];
const BLANK_OBJECT = {};
const BLANK_STRING = "";
const commentCacheVariables = { first: 1 };
const TEACHER_PERMISSION = ["CREATE", "PUBLISH"];

const getStudents = ({
  taggedStudentsList,
  defaultStudentNameOrderPreference,
}) => {
  return _.map(taggedStudentsList, item => {
    return {
      isArchived: _.get(item, "node.isArchived"),
      name: getFormattedUserName({
        user: _.get(item, ["node"]),
      }),
    };
  });
};

const postRatedLearningGoalsDetails = ({
  post,
  curriculumProgramType,
  showPostLearningGoals,
}) => {
  return showPostLearningGoals
    ? {
        elementPYP: _.get(post, "elementPYP"),
        curriculumProgramType: curriculumProgramType,
        showLearningGoalsEditor: false,
        showLearningGoalsPreview: true,
        propsIbPypElementRatings: _.get(post, "ibPYPElementRatings"),
        academicTerm: _.get(post, "academicTerm"),
      }
    : {};
};

let postRatedLearningGoalsDetailsBase = {
  elementPYP: [],
  curriculumProgramType: "",
  showLearningGoalsEditor: false,
  showLearningGoalsPreview: true,
  propsIbPypElementRatings: [],
  academicTerm: "",
};

const getStudentAttachments = selectStudentAttachmentData => {
  let allAttachments = [];

  if (!_.isNil(selectStudentAttachmentData)) {
    const attachmentsGroups = _.get(
      selectStudentAttachmentData,
      "attachmentGroups",
      []
    );
    _.forEach(attachmentsGroups, group => {
      const attachments = _.get(group, "attachments", []);
      allAttachments = _.concat(allAttachments, attachments);
    });
  }
  return allAttachments;
};

const getSelectedStudentAttachments = (
  selectedStudentActivityData,
  isRouitnePost,
  postTemplateFields
) => {
  let allAttachments = [];
  if (!_.isNil(selectedStudentActivityData) && isRouitnePost) {
    const attachmentObjectFields = postTemplateFields;
    const attachmentFieldIds = _.filter(attachmentObjectFields, {
      type: "ATTACHMENT",
    });

    const attachmentValues = _.filter(
      _.get(selectedStudentActivityData, "fields"),
      item => _.includes(_.map(attachmentFieldIds, "id"), item.uid)
    );

    const updatedAttacments = [];
    _.forEach(attachmentValues, attachmentObj => {
      updatedAttacments.push(
        ...(getStudentAttachments(
          _.get(attachmentObj, "resolvedMinimalTree")
        ) || [])
      );
    });

    return updatedAttacments;
  }

  if (!_.isNil(selectedStudentActivityData)) {
    const attachmentsGroups = _.get(
      selectedStudentActivityData,
      "attachmentGroups",
      []
    );
    _.forEach(attachmentsGroups, group => {
      const attachments = _.get(group, "attachments", []);
      allAttachments = _.concat(allAttachments, attachments);
    });
  }
  return allAttachments;
};

const TaggedText = React.memo(
  ({
    taggedStudents,
    elementPYP,
    createdByName,
    date,
    isPrivate,
    isHiddenFromStudents,
    userType,
    t,
    isStudentResponse,
    isStudentOwnResponse,
    isLETaggedAsResource,
    LEResource,
    assesmentData,
    onLEtextClick,
    setSharingModalVisibility,
    setTaggedStudents,
    isSidePaneContent,
    canOpenLEPreview,
    activityStudents,
    state,
    toggleLEPreview,
    assessmentId,
    defaultStudentNameOrderPreference,
    currentUserId,
    createdById,
    showAllStudentsInFilter,
    currentChildId,
    defaultStudentIdentifierNamePreference,
    isRoutinePost,
    useDSV2,
  }) => {
    const taggedStudentsList = taggedStudents;
    const hasTaggedStudents = !_.isEmpty(taggedStudentsList);

    let showTagged;
    if (userType === "staff") {
      showTagged = hasTaggedStudents;
    } else if (userType === "parent") {
      // dont show tagged if child itself is the creator of the post
      // showTagged = createdByName !== childName;

      showTagged = false;
    } else if (userType === "student") {
      showTagged = false;
    }

    const isPortfolio = taggedStudents.length > 0;
    const isPYPElement = !!elementPYP && elementPYP.length > 0;
    const timeTextClass = classNames(
      { [classes.timeText]: true },
      { [classes.evidenceTimeText]: !isPortfolio }
    );
    const filteredStudentsArray = _.filter(
      taggedStudents,
      student => student?.node?.id != createdById
    );
    const assesmentLinkContainerClass = classNames(
      { ["text-label"]: isPortfolioRevampAndIsJournalRoute() || useDSV2 },
      {
        [classes.assesmentLinkContainer]:
          !isPortfolioRevampAndIsJournalRoute() && !useDSV2,
      },
      {
        [classes.assesmentLinkContainerV2]:
          isPortfolioRevampAndIsJournalRoute() || useDSV2,
      },
      {
        [classes.noUnderlineAssessmentLink]: _.isEqual(userType, "staff")
          ? false
          : !_.isEmpty(activityStudents) ||
            !canOpenLEPreview ||
            (isPortfolioParityEnabledAndIsJournalRoute() && isSidePaneContent
              ? !_.isEmpty(filteredStudentsArray)
              : false),
      }
    );
    const hideEvidenceIndicator = userType !== "staff";

    const getSharedWithIcons = type => {
      switch (type) {
        case "everyone":
          return <GlobeOutlined size={"xxx-small"} variant={"subtle"} />;
        case "student":
          return <StudentOutlined size={"xxx-small"} variant={"subtle"} />;
        case "family":
          return <FamilyOutlined size={"xxx-small"} variant={"subtle"} />;
        case "private":
          return <LockOutlined size={"xxx-small"} variant={"subtle"} />;
        default:
          return null;
      }
    };

    const comp = (
      <div className={classes.taggedStudentsCountContainer}>
        {`${_.size(taggedStudentsList)} ${t("common:student_plural")}`}
      </div>
    );

    const onLEClick = e => {
      if (isSidePaneContent && canOpenLEPreview && !_.isEmpty(assessmentId)) {
        toggleLEPreview(assessmentId);
      }
      canOpenLEPreview && onLEtextClick(e);
    };

    const handleLEClick = useKeyDownWrapper(onLEClick);

    const showSharingModal = () => {
      if (hasTaggedStudents || (isPrivate && isHiddenFromStudents))
        setSharingModalVisibility(true);
      if (hasTaggedStudents)
        setTaggedStudents(
          _.map(
            taggedStudentsList,
            student => _.get(student, "node", BLANK_OBJECT),
            BLANK_ARRAY
          )
        );
    };

    const currentLoggedInUserId =
      userType === "parent" ? currentChildId : currentUserId;

    const currentUser = _.find(filteredStudentsArray, item =>
      _.isEqual(_.get(item, "node.id"), currentLoggedInUserId)
    )?.node;

    const tooltip = _.reduce(
      filteredStudentsArray,
      (tooltip, student, index) => {
        if (index == 0) return "";
        tooltip += `${getFormattedUserName({
          user: student,
        })}<br/>`;
        return tooltip;
      },
      ""
    );

    const tooltipStyle = {
      color: colors.textDefault,
      fontSize: "1.6rem",
      fontWeight: "600",
    };

    const tooltipStyleV2 = {
      color: "var(--neutral-200)",
      cursor: "pointer",
    };

    const tooltipLinkStyle = {
      textDecoration: "underline",
      ...tooltipStyle,
    };

    const tooltipLinkStyleV2 = {
      textDecoration: "underline",
      ...tooltipStyleV2,
    };

    const getSecondStudentInformation = () => {
      const excludeCurrentStudent = _.filter(
        filteredStudentsArray,
        item => _.get(item, "node.id") !== createdById
      );
      const isCurrentLoggedInUserTagged = _.find(
        excludeCurrentStudent,
        item => _.get(item, "node.id") === currentLoggedInUserId
      );
      if (isCurrentLoggedInUserTagged) {
        const otherStudent = _.find(
          excludeCurrentStudent,
          item => _.get(item, "node.id") !== currentLoggedInUserId
        );
        return getFormattedUserName({ user: _.get(otherStudent, "node") });
      } else {
        return getFormattedUserName({
          user: _.get(filteredStudentsArray[1], "node"),
        });
      }
    };

    const isUserTypeParent = userType === "parent";
    const getStudentNameFromList = (studentArray, id) => {
      const studentObject = _.filter(
        studentArray,
        item => _.get(item, "node.id") === id
      );
      return getFormattedUserName({
        user: _.first(studentObject)?.node,
      });
    };

    const handleShowSharingModal = useKeyDownWrapper(showSharingModal);
    const taggedAssesmentMessageClasses = classNames({
      [classes.taggedAssesmentMessageTextV2]:
        !isPortfolioRevampAndIsJournalRoute() && !useDSV2,
      ["text-label"]: isPortfolioRevampAndIsJournalRoute() || useDSV2,
      [classes.taggedAssesmentMessageTextV3]:
        isPortfolioRevampAndIsJournalRoute() || useDSV2,
    });

    const taggedCreatedByClasses = classNames({
      ["text-label"]: isPortfolioRevampAndIsJournalRoute() || useDSV2,
      [classes.taggedCreatedByTopContainerV2]:
        isPortfolioRevampAndIsJournalRoute() || useDSV2,
      [classes.taggedCreatedByTopContainer]:
        !isPortfolioRevampAndIsJournalRoute() && !useDSV2,
    });
    const renderCreatorDetails = () => {
      if (!isStudentResponse) {
        if (
          isLETaggedAsResource &&
          (isPortfolioParityEnabledAndIsJournalRoute()
            ? true
            : !isSidePaneContent)
        ) {
          return (
            <div>
              {/* Following <Trans> results: {teacher} tagged {assessment} to the post */}
              {isPortfolioParityEnabledAndIsJournalRoute() &&
              isSidePaneContent ? (
                <p
                  data-test-id="journal-feed-postcard-creatordetails"
                  className={taggedAssesmentMessageClasses}
                >
                  {/* Following <Trans> results: {teacher} shared {student}'s response to {assessment} */}
                  {!_.size(filteredStudentsArray) ? (
                    <Trans i18nKey={"journal:teacher_tagged_le_message"}>
                      <b className={taggedCreatedByClasses}>
                        {{ name: createdByName }}
                      </b>
                      <b
                        tabIndex={0}
                        className={assesmentLinkContainerClass}
                        onClick={onLEClick}
                        onKeyDown={handleLEClick}
                      >
                        {{
                          label: _.get(LEResource, "title.value", "assessment"),
                        }}
                      </b>
                    </Trans>
                  ) : null}
                  {_.size(filteredStudentsArray) > 2 ? (
                    <Trans
                      i18nKey={
                        "journal:user_tagged_shared_response_to_journal_others"
                      }
                    >
                      <b className={taggedCreatedByClasses}>
                        {{ createdBy: createdByName }}
                      </b>
                      {currentLoggedInUserId == _.get(currentUser, "id") ? (
                        <b className={taggedCreatedByClasses}>
                          {{
                            student: isUserTypeParent
                              ? getStudentNameFromList(
                                  filteredStudentsArray,
                                  _.get(currentUser, "id")
                                )
                              : t("common:you"),
                          }}
                        </b>
                      ) : (
                        <b className={taggedCreatedByClasses}>
                          {{
                            student: getFormattedUserName({
                              user: _.get(filteredStudentsArray, "[0].node"),
                            }),
                          }}
                        </b>
                      )}
                      {showAllStudentsInFilter ? (
                        <span
                          tabIndex={0}
                          className={classes.othersText}
                          style={
                            isPortfolioRevampAndIsJournalRoute() || useDSV2
                              ? tooltipLinkStyleV2
                              : tooltipLinkStyle
                          }
                          onClick={e => {
                            showSharingModal(e);
                          }}
                          onKeyDown={handleShowSharingModal}
                        >
                          <LinkWithTooltip
                            tooltip={tooltip}
                            placement="bottom"
                            linkStyles={
                              isPortfolioRevampAndIsJournalRoute() || useDSV2
                                ? tooltipLinkStyleV2
                                : tooltipLinkStyle
                            }
                          >
                            <b className={classes.othersTooltipContainer}>
                              {{
                                remainingStudentsCount:
                                  _.size(filteredStudentsArray) - 1,
                              }}
                            </b>
                          </LinkWithTooltip>
                        </span>
                      ) : (
                        <span style={tooltipStyle}>
                          {" "}
                          <b className={classes.othersTooltipContainer}>
                            {{
                              remainingStudentsCount:
                                _.size(filteredStudentsArray) - 1,
                            }}
                          </b>
                        </span>
                      )}
                      <b
                        tabIndex={0}
                        className={assesmentLinkContainerClass}
                        onClick={onLEClick}
                        onKeyDown={handleLEClick}
                      >
                        {{
                          label: _.get(LEResource, "title.value", "assessment"),
                        }}
                      </b>
                    </Trans>
                  ) : null}

                  {_.size(filteredStudentsArray) === 2 &&
                  showAllStudentsInFilter ? (
                    <Trans
                      i18nKey={
                        "journal:user_tagged_shared_response_to_journal_tagged"
                      }
                    >
                      <b className={taggedCreatedByClasses}>
                        {{ createdBy: createdByName }}
                      </b>
                      {currentLoggedInUserId == _.get(currentUser, "id") ? (
                        <b className={taggedCreatedByClasses}>
                          {{
                            student1: isUserTypeParent
                              ? getStudentNameFromList(
                                  filteredStudentsArray,
                                  _.get(currentUser, "id")
                                )
                              : t("common:you"),
                          }}
                        </b>
                      ) : (
                        <b className={taggedCreatedByClasses}>
                          {{
                            student1: getFormattedUserName({
                              user: _.get(filteredStudentsArray, "[0].node"),
                            }),
                          }}
                        </b>
                      )}
                      <b className={taggedCreatedByClasses}>
                        {{
                          student2: getFormattedUserName({
                            user: filteredStudentsArray[1]?.node,
                          }),
                        }}
                      </b>
                      <b
                        tabIndex={0}
                        className={assesmentLinkContainerClass}
                        onClick={onLEClick}
                        onKeyDown={handleLEClick}
                      >
                        {{
                          label: _.get(LEResource, "title.value", "assessment"),
                        }}
                      </b>
                    </Trans>
                  ) : _.size(filteredStudentsArray) === 2 ? (
                    <Trans
                      i18nKey={
                        "journal:user_tagged_shared_response_to_journal_single_tagged"
                      }
                    >
                      <b className={taggedCreatedByClasses}>
                        {{ createdBy: createdByName }}
                      </b>
                      {currentLoggedInUserId == _.get(currentUser, "id") ? (
                        <b className={taggedCreatedByClasses}>
                          {{
                            student: isUserTypeParent
                              ? getStudentNameFromList(
                                  filteredStudentsArray,
                                  _.get(currentUser, "id")
                                )
                              : t("common:you"),
                          }}
                        </b>
                      ) : (
                        <b className={taggedCreatedByClasses}>
                          {{
                            student: getFormattedUserName({
                              user: _.get(filteredStudentsArray, "[0].node"),
                            }),
                          }}
                        </b>
                      )}

                      <b
                        tabIndex={0}
                        className={assesmentLinkContainerClass}
                        onClick={onLEClick}
                        onKeyDown={handleLEClick}
                      >
                        {{
                          label: _.get(LEResource, "title.value", "assessment"),
                        }}
                      </b>
                    </Trans>
                  ) : null}

                  {_.size(filteredStudentsArray) === 1 ? (
                    <Trans
                      i18nKey={
                        "journal:user_tagged_shared_response_to_journal_single_tagged"
                      }
                    >
                      <b className={taggedCreatedByClasses}>
                        {{ createdBy: createdByName }}
                      </b>
                      {currentLoggedInUserId == _.get(currentUser, "id") ? (
                        <b className={taggedCreatedByClasses}>
                          {{
                            student: isUserTypeParent
                              ? getStudentNameFromList(
                                  filteredStudentsArray,
                                  _.get(currentUser, "id")
                                )
                              : t("common:you"),
                          }}
                        </b>
                      ) : (
                        <b className={taggedCreatedByClasses}>
                          {{
                            student: getFormattedUserName({
                              user: _.get(filteredStudentsArray, "[0].node"),
                            }),
                          }}
                        </b>
                      )}

                      <b
                        tabIndex={0}
                        className={assesmentLinkContainerClass}
                        onClick={onLEClick}
                        onKeyDown={handleLEClick}
                      >
                        {{
                          label: _.get(LEResource, "title.value", "assessment"),
                        }}
                      </b>
                    </Trans>
                  ) : null}
                </p>
              ) : (
                <p className={classes.taggedAssesmentMessageText}>
                  <Trans i18nKey="journal:teacher_tagged_le_message">
                    <b className={taggedCreatedByClasses}>
                      {{ name: createdByName }}
                    </b>
                    <b
                      tabIndex={0}
                      className={assesmentLinkContainerClass}
                      onClick={onLEClick}
                      onKeyDown={handleLEClick}
                    >
                      {{
                        label: _.get(LEResource, "title.value", "assessment"),
                      }}
                    </b>
                  </Trans>
                </p>
              )}
            </div>
          );
        } else {
          const isSidePaneContentUsage =
            isPortfolioParityEnabledAndIsJournalRoute() && isSidePaneContent;
          const taggedAssesmentMessageTextClass = classNames({
            [classes.taggedAssesmentMessageText]: !isSidePaneContentUsage,
            [classes.taggedAssesmentMessageTextV2]:
              isSidePaneContentUsage &&
              !isPortfolioRevampAndIsJournalRoute() &&
              !useDSV2,
            ["text-label"]: isPortfolioRevampAndIsJournalRoute() || useDSV2,
            [classes.taggedAssesmentMessageTextV3]:
              (isSidePaneContentUsage &&
                isPortfolioRevampAndIsJournalRoute()) ||
              useDSV2,
          });
          const studentIds = _.map(filteredStudentsArray, student =>
            _.get(student, "node.id")
          );
          if (
            _.size(activityStudents) === 1 ||
            (isSidePaneContentUsage &&
              (_.size(filteredStudentsArray) === 1 ||
                (!showAllStudentsInFilter &&
                  _.includes(studentIds, currentLoggedInUserId))))
          ) {
            return (
              <div>
                {/* Following <Trans> results: {teacher} tagged {student} */}
                <p
                  className={taggedAssesmentMessageTextClass}
                  data-test-id="journal-feed-postcard-creatordetails"
                >
                  <Trans i18nKey="journal:teacher_tagged_student">
                    <b className={taggedCreatedByClasses}>
                      {{ teacherName: createdByName }}
                    </b>
                    <b
                      className={assesmentLinkContainerClass}
                      style={{
                        textDecoration: isSidePaneContentUsage ? "none" : "",
                      }}
                    >
                      {{
                        studentName: isSidePaneContentUsage
                          ? currentLoggedInUserId == _.get(currentUser, "id")
                            ? isUserTypeParent
                              ? getStudentNameFromList(
                                  filteredStudentsArray,
                                  _.get(currentUser, "id")
                                )
                              : t("common:you")
                            : getFormattedUserName({
                                user: _.get(filteredStudentsArray, "[0].node"),
                              })
                          : getFormattedUserName({
                              user: _.get(activityStudents, [
                                "0",
                                "item",
                                isRoutinePost
                                  ? "routineStudent"
                                  : "activityStudent",
                              ]),
                            }),
                      }}
                    </b>
                  </Trans>
                </p>
              </div>
            );
          }
          if (
            (!isSidePaneContent && _.size(activityStudents) === 2) ||
            (isSidePaneContentUsage &&
              _.size(filteredStudentsArray) === 2 &&
              showAllStudentsInFilter)
          ) {
            return (
              <div>
                {/* Following <Trans> results: {user} tagged {student1} and {student2} */}
                <ConditionalWrapper
                  type={"wrapperAsElement"}
                  condition={isSidePaneContentUsage}
                  wrapper={
                    <DSTooltip
                      tooltip={
                        isSidePaneContentUsage
                          ? getSecondStudentInformation()
                          : getFormattedUserName({
                              user: _.get(activityStudents, [
                                "1",
                                "item",
                                isRoutinePost
                                  ? "routineStudent"
                                  : "activityStudent",
                              ]),
                            })
                      }
                      placement={"bottom"}
                    />
                  }
                >
                  <p
                    className={taggedAssesmentMessageTextClass}
                    data-test-id="journal-feed-postcard-creatordetails"
                  >
                    <Trans i18nKey="journal:user_tagged_student_and_student">
                      <b className={taggedCreatedByClasses}>
                        {{ user: createdByName }}
                      </b>
                      <b
                        className={assesmentLinkContainerClass}
                        style={{
                          textDecoration: isSidePaneContentUsage ? "none" : "",
                        }}
                      >
                        {{
                          student1: isSidePaneContentUsage
                            ? currentLoggedInUserId == _.get(currentUser, "id")
                              ? isUserTypeParent
                                ? getStudentNameFromList(
                                    filteredStudentsArray,
                                    _.get(currentUser, "id")
                                  )
                                : t("common:you")
                              : getFormattedUserName({
                                  user: _.get(
                                    filteredStudentsArray,
                                    "[0].node"
                                  ),
                                })
                            : getFormattedUserName({
                                user: _.get(activityStudents, [
                                  "0",
                                  "item",
                                  isRoutinePost
                                    ? "routineStudent"
                                    : "activityStudent",
                                ]),
                              }),
                        }}
                      </b>
                      <b
                        className={assesmentLinkContainerClass}
                        style={{
                          textDecoration: isSidePaneContentUsage ? "none" : "",
                        }}
                      >
                        {{
                          student2: isSidePaneContentUsage
                            ? getSecondStudentInformation()
                            : getFormattedUserName({
                                user: _.get(activityStudents, [
                                  "1",
                                  "item",
                                  isRoutinePost
                                    ? "routineStudent"
                                    : "activityStudent",
                                ]),
                              }),
                        }}
                      </b>
                    </Trans>
                  </p>
                </ConditionalWrapper>
              </div>
            );
          }
          if (
            (!isSidePaneContent && _.size(activityStudents) > 2) ||
            (isSidePaneContentUsage &&
              _.size(filteredStudentsArray) > 2 &&
              showAllStudentsInFilter)
          ) {
            return (
              <div>
                {/* Following <Trans> results: {user} tagged {student} and {remainingStudentsCount} others */}
                <p
                  className={taggedAssesmentMessageTextClass}
                  data-test-id="journal-feed-postcard-creatordetails"
                >
                  <Trans i18nKey="journal:user_tagged_student_and_others">
                    <b className={taggedCreatedByClasses}>
                      {{ user: createdByName }}
                    </b>
                    <b
                      className={assesmentLinkContainerClass}
                      style={{
                        textDecoration: isSidePaneContentUsage ? "none" : "",
                      }}
                    >
                      {{
                        student:
                          currentLoggedInUserId == _.get(currentUser, "id")
                            ? isUserTypeParent
                              ? getStudentNameFromList(
                                  filteredStudentsArray,
                                  _.get(currentUser, "id")
                                )
                              : t("common:you")
                            : getFormattedUserName({
                                user: isSidePaneContentUsage
                                  ? _.get(filteredStudentsArray, "[0].node")
                                  : _.get(activityStudents, [
                                      "0",
                                      "item",
                                      isRoutinePost
                                        ? "routineStudent"
                                        : "activityStudent",
                                    ]),
                              }),
                      }}
                    </b>

                    {isSidePaneContentUsage ? (
                      <span
                        className={classes.othersText}
                        tabIndex={0}
                        onKeyDown={handleShowSharingModal}
                        style={
                          isPortfolioRevampAndIsJournalRoute() || useDSV2
                            ? tooltipLinkStyleV2
                            : tooltipLinkStyle
                        }
                        onClick={e => {
                          showSharingModal(e);
                        }}
                      >
                        <LinkWithTooltip
                          tooltip={tooltip}
                          placement="bottom"
                          linkStyles={
                            isPortfolioRevampAndIsJournalRoute() || useDSV2
                              ? tooltipLinkStyleV2
                              : tooltipLinkStyle
                          }
                        >
                          <b className={classes.othersTooltipContainer}>
                            {{
                              remainingStudentsCount:
                                _.size(filteredStudentsArray) - 1,
                            }}
                          </b>
                        </LinkWithTooltip>
                      </span>
                    ) : (
                      <b className={assesmentLinkContainerClass}>
                        <DSTooltip
                          tooltip={
                            <span>
                              {_.map(activityStudents, student => (
                                <span>
                                  {getFormattedUserName({
                                    user: _.get(student, [
                                      "item",
                                      isRoutinePost
                                        ? "routineStudent"
                                        : "activityStudent",
                                    ]),
                                  })}
                                </span>
                              ))}
                            </span>
                          }
                        >
                          {{
                            remainingStudentsCount:
                              _.size(activityStudents) - 1,
                          }}
                        </DSTooltip>
                      </b>
                    )}
                  </Trans>
                </p>
              </div>
            );
          }
          return (
            <div
              data-test-id="journal-feed-postcard-creatordetails"
              className={taggedCreatedByClasses}
            >
              {createdByName}
            </div>
          );
        }
      } else {
        const content = _.get(
          assesmentData,
          "assesment.assignment.content",
          ""
        );
        if (isStudentOwnResponse) {
          return (
            <div>
              {/* Following <Trans> results: {student} shared thier own response to {assessment}  */}
              <p
                className={classes.taggedAssesmentMessageText}
                data-test-id="journal-feed-postcard-creatordetails"
              >
                <Trans i18nKey={"journal:shared_own_response_to_journal"}>
                  <b className={taggedCreatedByClasses}>
                    {{ name: createdByName }}
                  </b>
                  {
                    <b
                      tabIndex={0}
                      className={assesmentLinkContainerClass}
                      onClick={onLEClick}
                      onKeyDown={handleLEClick}
                    >
                      {{ label: _.get(content, "title.value", "assessment") }}
                    </b>
                  }
                </Trans>
              </p>
            </div>
          );
        } else {
          const isSidePaneContentUsage =
            isPortfolioParityEnabledAndIsJournalRoute() && isSidePaneContent;
          return (
            <div style={{ display: "flex" }}>
              {/* Following <Trans> results: {teacher} shared {student}'s response to {assessment} */}
              <p
                className={
                  (isSidePaneContentUsage &&
                    isPortfolioRevampAndIsJournalRoute()) ||
                  useDSV2
                    ? classes.taggedAssesmentMessageTextV3
                    : isSidePaneContentUsage
                    ? classes.taggedAssesmentMessageTextV2
                    : classes.taggedAssesmentMessageText
                }
                data-test-id="journal-feed-postcard-creatordetails"
              >
                <Trans
                  i18nKey={
                    isSidePaneContent && !isSidePaneContentUsage
                      ? "journal:shared_response_to_journal_without_label"
                      : "journal:shared_response_to_journal"
                  }
                >
                  <b className={taggedCreatedByClasses}>
                    {{ createdBy: createdByName }}
                  </b>
                  <b className={taggedCreatedByClasses}>
                    {{
                      student: getFormattedUserName({
                        user: _.get(assesmentData, "student", BLANK_OBJECT),
                      }),
                    }}
                  </b>
                  {(!isSidePaneContent || isSidePaneContentUsage) && (
                    <b
                      tabIndex={0}
                      className={assesmentLinkContainerClass}
                      onClick={onLEClick}
                      onKeyDown={handleLEClick}
                    >
                      {{ label: _.get(content, "title.value", "assessment") }}
                    </b>
                  )}
                </Trans>
              </p>
            </div>
          );
        }
      }
    };

    return (
      <div className={classes.taggedTextContainer}>
        <span className={classes.taggedCreatedByText}>
          {renderCreatorDetails()}

          {/* show shared with text to only staff */}
          <div
            className={classNames({
              [classes.taggedCreatedByBottomContainer]: true,
              [classes.taggedCreatedByBottomContainerV2]:
                isPortfolioRevampAndIsJournalRoute() || useDSV2,
            })}
            style={
              isPortfolioParityEnabledAndIsJournalRoute()
                ? style.taggedCreatedByBottomContainerStyle
                : BLANK_OBJECT
            }
          >
            <span
              className={timeTextClass}
              data-test-id="journal-feed-postcard-posttime"
            >
              {state == "SCHEDULED" ? null : getTimeSince(date, t)}
            </span>
            {userType === "staff" ? (
              <React.Fragment>
                {state != "SCHEDULED" ? (
                  <div className={classes.dotContainer}>
                    <div className={classes.dot}></div>
                  </div>
                ) : null}

                {isRoutinePost ? (
                  <div className={classes.iconContainer}>
                    <DSTooltip
                      trigger={TRIGGER_EVENT_TYPES}
                      tooltip={getSharedWithString({
                        isPrivate,
                        isHiddenFromStudents,
                        withPrefix: true,
                        t,
                      })}
                      placement={"bottom"}
                      dsVersion="2.0"
                      showArrow={true}
                    >
                      <IconButton
                        dsVersion="2.0"
                        className={classes.icon}
                        onClick={showSharingModal}
                        icon={getSharedWithIcons(
                          getSharedWithStringV2({
                            isPrivate,
                            isHiddenFromStudents,
                          })
                        )}
                        type="plain"
                        variant={"neutral"}
                        size={"xx-small"}
                        testId="journal:feed:postcard:sharedwithicon"
                      />
                    </DSTooltip>
                  </div>
                ) : (
                  <div className={classes.iconContainer}>
                    <DSTooltip
                      dsVersion="2.0"
                      showArrow={true}
                      tooltip={getSharedWithString({
                        isPrivate,
                        isHiddenFromStudents,
                        withPrefix: true,
                        t,
                      })}
                    >
                      <IconButton
                        dsVersion="2.0"
                        className={classes.icon}
                        onClick={showSharingModal}
                        icon={getSharedWithIcons(
                          getSharedWithStringV2({
                            isPrivate,
                            isHiddenFromStudents,
                          })
                        )}
                        variant="plain"
                        type="plain"
                        size="small"
                        testId="journal:feed:postcard:sharedwithicon"
                      />
                    </DSTooltip>
                  </div>
                )}

                {state == "SCHEDULED" ? (
                  <div className={classes.dotContainer}>
                    <div className={classes.dot}></div>
                  </div>
                ) : null}
              </React.Fragment>
            ) : null}
            {state == "SCHEDULED" ? (
              <span className={timeTextClass}>
                <span
                  className={classes.scheduleIconWithTime}
                  data-test-id="journal-feed-postcard-scheduledtime"
                >
                  {t("common:scheduled_for_with_label", {
                    label: moment(date).format("MMM DD YYYY, hh:mm A"),
                  })}
                </span>
              </span>
            ) : null}
          </div>
        </span>
      </div>
    );
  }
);

TaggedText.displayName = "TaggedText";

const ModelContent = React.memo(
  ({
    attachments,
    toggleMediaModal,
    showMediaModal,
    activeIndex,
    toggleDownloadBeginOverlay,
    t,
    curriculumProgramType,
    post,
    isStudentResponse,
    canCreateComment,
    postViewMode,
    updatePostStatus,
    onPostActionClick,
    onPostSidePaneCloseClick,
    fromPropsActivitySelectedStudentId,
    fromPropsHandleActivitySelectedStudentChange,
    fromPropsHandleActivitySelectedStudentAttachmentsChange,
    staffEditAccess = true,
    hideViews = false,
    hideLike,
    hideComments,
    hideLearninGoals,
    hideTaggedStudents,
    hideUnitDetails,
    showTaggedFolders,
    taggedStudents,
    showPostLearningGoals,
    canDownloadMedia = true,
    sourceType,
    paramPostId,
    isViewFromPostPage,
    openedFromNotification,
    canEditOrDelete,
    postRatedLearningGoalsDetailsBase,
    useDSV2,
    postCardStyles,
    isViewFromUnitPlanReflection,
    learningCourseIdFromProps,
  }) => {
    const parentRef = useRef(null);
    const onCloseClickLocal = useCallback(value => {
      if (_.isFunction(onPostSidePaneCloseClick)) onPostSidePaneCloseClick();
      fromPropsHandleActivitySelectedStudentChange("");
      toggleMediaModal(value);
    }, []);

    const onDiscardDirectly = useCallback(() => {
      onCloseClickLocal(false);
    }, []);

    const onCloseClick = () => {
      onCloseClickLocal(false);
    };

    const mediaAttachments = useMemo(() => ({ attachments: attachments }), [
      attachments,
    ]);
    const postId = sourceType == "PUBLIC_URL" ? paramPostId : post?.id;
    return showMediaModal ? (
      showNewTheatreMode() ? (
        !isStudentResponse ? (
          <div ref={parentRef}>
            <TheatreModeV2
              mediaAttachments={mediaAttachments}
              activeAttachmentIndex={activeIndex}
              toggleTheatreMode={onCloseClickLocal}
              iframeIdSelector={"workbook-iframe-journal"}
              onDiscardDirectly={onDiscardDirectly}
              postRatedLearningGoalsDetails={postRatedLearningGoalsDetails({
                post,
                curriculumProgramType,
                showPostLearningGoals: showPostLearningGoals,
              })}
              taggedStudents={taggedStudents}
              canDownloadMedia={canDownloadMedia}
              learningCourseIdFromProps={learningCourseIdFromProps}
              sidePaneContent={
                // PostDetail will receive setTheatreAttachmentIndex(index), theatreActiveAttachmentIndex, setTheatreAttachmentById({id, type}) and theatreActiveAttachmentId as a props.
                <PostDetail
                  postId={postId}
                  onCloseClick={onCloseClick}
                  showComment={false} // false to not show comments screen initially
                  customDetailText={t("common:view_with_label_lowercase", {
                    label: t("common:post"),
                  })}
                  isRightPaneChat={true}
                  mediaMaxHeight={480}
                  canCreateComment={canCreateComment}
                  isSidePaneContent={true}
                  mode={postViewMode ? "edit" : "view"}
                  showCloseBtn={false}
                  showCommentBackButton={true}
                  showAttachmentAsMediaCard={true}
                  updatePostStatus={updatePostStatus}
                  onPostActionClick={onPostActionClick}
                  fromPropsActivitySelectedStudentId={
                    fromPropsActivitySelectedStudentId
                  }
                  fromPropsHandleActivitySelectedStudentAttachmentsChange={
                    fromPropsHandleActivitySelectedStudentAttachmentsChange
                  }
                  staffEditAccess={staffEditAccess}
                  hideViews={hideViews}
                  hideLike={hideLike || !staffEditAccess}
                  hideComments={hideComments || !staffEditAccess}
                  hideLearninGoals={hideLearninGoals}
                  hideTaggedStudents={hideTaggedStudents}
                  hideUnitDetails={hideUnitDetails}
                  showTaggedFolders={showTaggedFolders}
                  isViewFromPostPage={isViewFromPostPage}
                  openedFromNotification={openedFromNotification}
                  canEditOrDelete={canEditOrDelete}
                  useDSV2={useDSV2}
                  postCardStyles={postCardStyles}
                  isViewFromUnitPlanReflection={isViewFromUnitPlanReflection}
                />
              }
            />
          </div>
        ) : null
      ) : (
        <MediaModal
          toggleMediaModal={toggleMediaModal}
          attachments={attachments}
          activeIndex={activeIndex}
          toggleDownloadBeginOverlay={toggleDownloadBeginOverlay}
          videoAutoPlayOnClick={true}
          showDownloadVideoButton={true}
        />
      )
    ) : null;
  }
);
ModelContent.displayName = "ModelContent";

const getHasManageAccess = ({
  userType,
  isRnpEnabled,
  hasManageAccessForStudentPortfolio,
  hasRoutinesManageAccess,
}) => {
  const isStudentFeed = _.includes(window.location.href, "/studentFeed");
  const isRoutinesRoute = _.includes(window.location.href, "/routines");

  if (isStudentFeed && userType === "staff" && isRnpEnabled) {
    return hasManageAccessForStudentPortfolio;
  }
  if (isRoutinesRoute && isRnpEnabled && userType === "staff") {
    return hasRoutinesManageAccess;
  }
  if (isRoutinesRoute && isRnpEnabled) {
    return hasRoutinesManageAccess;
  }
  if (isRoutinesRoute) {
    return true;
  }
  return canManagePortfolioActions(userType);
};

class PostCard extends React.PureComponent {
  constructor(props) {
    super(props);
    const isRoutinePost = _.get(props, "isRoutinePost");
    this.state = {
      showMediaModal: false,
      showDownloadBeginOverlay: false,
      isSharingModalOpen: false,
      taggedStudentsForModal: [],
      showTranslatedText: false,
      titleText: _.get(props, "item.title", ""),
      isLikesModalOpen: false,
      isViewsModalOpen: false,
      showCommentBox: false,
      showViewAllComments: true,
      commentToEdit: {},
      refetchComment: false,
      showCommentBar: false,
      activitySelectedStudentId: !_.isEmpty(
        _.get(props, "fromPropsActivitySelectedStudentId", "")
      )
        ? _.get(props, "fromPropsActivitySelectedStudentId", "")
        : _.get(
            props,
            [
              "filteredStudentActivities",
              0,
              "item",
              isRoutinePost ? "routineStudent" : "activityStudent",
              "id",
            ],
            ""
          ),
      attachments: _.get(props, "item.attachments", []),
      activeIndex: 0,
    };
    this.embedPlayerRef = createRef();
    this.commentBoxRef = createRef();
    this.containerRef = createRef();
  }

  componentDidMount = () => {
    const {
      item: post,
      item: { id },
      userId,
      markPostAsSeenByUser,
      userType,
      isViewFromPostPage = false,
      curriculumProgramType,
      openMediaOnLoad = false,
    } = this.props;
    if (
      userType === "parent" &&
      _.isNil(isPostSeenByUser({ postId: id, userId: userId })) &&
      isViewFromPostPage == false
    ) {
      markPostAsSeenByUser({
        parentIds: [id],
        userId: userId,
        postDetails: post,
      });
    }

    if (this.props?.openedFromNotification && showNewTheatreMode()) {
      this.openPostDetails();
    }
    const showPostLearningGoals = _.get(
      this.props,
      "showPostLearningGoals",
      true
    );
    if (showPostLearningGoals) {
      postRatedLearningGoalsDetailsBase = {
        elementPYP: _.get(post, "elementPYP"),
        curriculumProgramType: curriculumProgramType,
        showLearningGoalsEditor: false,
        showLearningGoalsPreview: true,
        propsIbPypElementRatings: _.get(post, "ibPYPElementRatings"),
        academicTerm: _.get(post, "academicTerm"),
      };
    }

    if (openMediaOnLoad) {
      this.onMediaClick({ activeIndex: 0 });
    }
  };

  componentDidUpdate = prevProps => {
    // Update attachments if post attachment is edited
    if (
      !_.isEqual(
        _.get(prevProps, "item.attachments"),
        _.get(this.props, "item.attachments")
      )
    )
      this.setState({ attachments: _.get(this.props, "item.attachments", []) });

    if (
      !_.isEqual(
        _.get(prevProps, "fromPropsActivitySelectedStudentId", ""),
        _.get(this.props, "fromPropsActivitySelectedStudentId", "")
      )
    ) {
      this.setState({
        activitySelectedStudentId: _.get(
          this.props,
          "fromPropsActivitySelectedStudentId",
          ""
        ),
      });

      if (
        _.get(this.props, "openedFromNotification", false) &&
        _.isFunction(_.get(this.props, "setTheatreAttachmentIndex"))
      )
        this.props.setTheatreAttachmentIndex(0);
    }
  };

  componentWillUnmount = () => {
    postRatedLearningGoalsDetailsBase = {};
  };

  onPostActionClick = params => {
    const {
      item,
      onPostActionClick,
      isSidePaneContent,
      staffEditAccess = true,
      filteredStudentActivities,
      isRoutinePost,
    } = this.props;
    if (
      !isSidePaneContent &&
      _.size(filteredStudentActivities) > 1 &&
      _.get(params, "action", "") === "LIKE"
    ) {
      // if multiple students are tagged in activity post, then like action should open theatre mode instead of like operation
      this.openPostDetails();
      return;
    }

    const selectedActivityStudentIndex =
      !_.isEmpty(filteredStudentActivities) &&
      !_.isEmpty(this.state.activitySelectedStudentId)
        ? _.findIndex(
            filteredStudentActivities,
            activity =>
              _.get(activity, [
                "item",
                isRoutinePost ? "routineStudent" : "activityStudent",
                "id",
              ]) === this.state.activitySelectedStudentId
          )
        : -1;

    const activityId =
      selectedActivityStudentIndex !== -1
        ? _.get(
            filteredStudentActivities,
            [selectedActivityStudentIndex, "item", "id"],
            ""
          )
        : "";
    const activityType =
      selectedActivityStudentIndex !== -1
        ? _.get(
            filteredStudentActivities,
            [selectedActivityStudentIndex, "itemType"],
            ""
          )
        : "";

    onPostActionClick({
      ...params,
      item,
      staffEditAccess,
      activityId,
      activityType,
      id: _.get(item, "id"),
    });

    if (params?.action === "COMMENT") {
      this.setState({
        showCommentBox: this.props.canCreateComment,
        showCommentBar: this.props.canCreateComment,
      });
      if (!isSidePaneContent) this.openPostDetails();
      scrollIntoView({
        element: this.containerRef.current,
        block: "end",
        inline: "end",
      });
      setTimeout(() => {
        if (this.commentBoxRef && this.commentBoxRef?.current) {
          this.commentBoxRef?.current?.focus();
        }
      });
    }
    if (
      this.embedPlayerRef &&
      this.embedPlayerRef.current &&
      (params?.action === "POST_DETAIL" ||
        params?.action === "COMMENT" ||
        params?.action === "POST_EDIT")
    ) {
      this.embedPlayerRef?.current?.pause();
    }
  };

  onStudentResponseClick = id => {
    this.onPostActionClick({ id, action: "POST_DETAIL" });
  };

  canOpenLEPreview = () => {
    const { userType, curriculumProgramId, sourceType } = this.props;

    const showLEPreview =
      sourceType !== "PUBLIC_URL" &&
      (userType !== "parent"
        ? true
        : getSettingValue({
            name: "FamilyCanViewTaggedLearningExperience",
            currentCurriculumProgramId: curriculumProgramId,
          }));

    return showLEPreview;
  };

  onLEClick = (id, assessmentId) => {
    this.onPostActionClick({
      id,
      action: "LE_PREVIEW",
      assessmentId: assessmentId,
    });
  };

  toggleDownloadBeginOverlay = () => {
    this.setState({ showDownloadBeginOverlay: true });
  };

  toggleMediaModal = (value, activeIndex) => {
    this.setState({
      showMediaModal: value,
      activeIndex: activeIndex,
    });
    if (!value) {
      if (_.get(this.props, "hideComments")) return;
      syncPostCommentsCache({
        postId: _.get(this.props, "item.id"),
        variables: commentCacheVariables,
        fragment: PostCommentFragment,
      });
    }
  };

  onMediaClick = ({ activeIndex = 0 }) => {
    if (
      _.get(this.props, "isSidePaneContent", false) == true &&
      showNewTheatreMode()
    ) {
      if (_.isFunction(_.get(this.props, "setTheatreAttachmentIndex")))
        this.props?.setTheatreAttachmentIndex(activeIndex);
      else this.toggleMediaModal(true, activeIndex);
    } else {
      this.toggleMediaModal(true, activeIndex);
    }
  };

  onMediaCardKeydown = index => e => {
    onEnterOrSpaceKeyDown(e, () => this.onMediaClick({ activeIndex: index }));
  };

  openPostDetails = () => {
    const { item } = this.props;
    if (showNewTheatreMode()) {
      this.onMediaClick({ activeIndex: 0 });
      if (this.embedPlayerRef && this.embedPlayerRef?.current) {
        this.embedPlayerRef?.current?.pause();
      }
    } else {
      const id = _.get(item, "id", BLANK_STRING);
      const items = _.get(item, "items", BLANK_OBJECT);
      const assesmentData = _.find(
        items,
        item => _.get(item, "itemType", "") === "STUDENT_ASSIGNMENT"
      );

      !_.isEmpty(assesmentData)
        ? this.onStudentResponseClick(id)
        : this.onPostActionClick({ id, action: "POST_DETAIL" });
    }
  };

  updateEmbedPlayerRef = ref => {
    if (this.embedPlayerRef) this.embedPlayerRef.current = ref;
  };

  toggleTranslatedText = () => {
    this.setState({ showTranslatedText: !this.state.showTranslatedText });
  };

  toggleLikeModal = state => {
    this.setState({ isLikesModalOpen: state });
  };

  toggleViewsModal = state => {
    this.setState({ isViewsModalOpen: state });
  };

  setTitleText = text => {
    this.setState({ titleText: text });
  };

  // used in StudentResponseV2 to toggle MediaModal state of its parent postcard
  toggleParentMediaModalState = value => {
    const { onCloseClick } = this.props;
    if (_.isFunction(onCloseClick)) onCloseClick();
    this.toggleMediaModal(value);
  };

  setRefetchComment = value => {
    this.setState({ refetchComment: value });
  };

  onEditComment = editComment => {
    this.setState({ commentToEdit: editComment });
  };

  setCommentBar = value => {
    this.setState({ showCommentBar: value });
  };

  handleActivitySelectedStudentChange = studentId => {
    if (_.isEmpty(studentId))
      this.setState({
        activitySelectedStudentId: !_.isEmpty(
          _.get(this.props, "fromPropsActivitySelectedStudentId", "")
        )
          ? _.get(this.props, "fromPropsActivitySelectedStudentId", "")
          : _.get(
              this.props,
              [
                "filteredStudentActivities",
                0,
                "item",
                this.props.isRoutinePost ? "routineStudent" : "activityStudent",
                "id",
              ],
              ""
            ),
      });
    else
      this.setState({
        activitySelectedStudentId: studentId,
      });
    this.toggleMediaModal(true);
  };

  handleActivitySelectedStudentAttachmentsChange = (
    setTheatreAttachmentIndex,
    attachments
  ) => {
    setTheatreAttachmentIndex?.(this.state.activeIndex);
    this.setState({ attachments });
  };

  handleActivitySelectedStudentIdChange = studentId => {
    this.setState({
      activitySelectedStudentId: studentId,
    });
  };

  hideCommentBar = () => {
    this.setState({ showCommentBox: false, showCommentBar: false });
  };

  // Don't show post card when post contains only assessment tools and "family can view evaluation" setting is OFF
  shouldHidePostCardToFamily = ({
    assessment,
    curriculumProgramId,
    userType,
  }) => {
    const isFromJournalRoute = _.includes(
      _.get(this.props, "location.pathname", ""),
      "/journal"
    );
    if (userType != "parent" || !isFromJournalRoute) return false;
    const hasAssesmentTool =
      _.size(
        _.get(assessment, "assignment.content.assessmentTools.edges", [])
      ) > 0;
    const hasAttachmentsInResponse =
      _.size(_.get(assessment, "submission.attachmentGroups", [])) > 0;

    return (
      userType == "parent" &&
      hasAssesmentTool &&
      !hasAttachmentsInResponse &&
      getSettingValue({
        name: "FamilyCanViewEvaluation",
        currentCurriculumProgramId: curriculumProgramId,
      }) == false
    );
  };

  onEditPostClick = () => {
    const assesmentData = _.find(
      this.props.item.items,
      item => _.get(item, "itemType", "") === "STUDENT_ASSIGNMENT"
    );
    const itemType = _.get(assesmentData, "itemType", "");
    const isAddLEToJournal = _.isEqual(itemType, "STUDENT_ASSIGNMENT");

    if (this.props.userType === "staff") {
      const studentActivityType = !_.isEmpty(
        this.props.filteredStudentActivities
      )
        ? _.get(
            _.first(this.props.filteredStudentActivities),
            "item.activityType"
          )
        : undefined;

      this.props.onPostActionClick({
        id: this.props.item.id,
        action: "POST_EDIT",
        isAddLEToJournal: isAddLEToJournal,
        params: {
          ...(!_.isNil(studentActivityType)
            ? { studentActivityType }
            : BLANK_OBJECT),
        },
      });
      if (_.isFunction(this.props?.onCloseClick)) this.props.onCloseClick();
      this.toggleMediaModal(false);
      return;
    }

    this.props.onPostActionClick({
      id: this.props.item.id,
      action: "POST_EDIT",
      isAddLEToJournal: isAddLEToJournal,
    });
    if (_.isFunction(this.props?.onCloseClick)) this.props.onCloseClick();
    this.toggleMediaModal(false);
  };

  setSharingModalVisibility = modalState => {
    this.setState({ isSharingModalOpen: modalState });
  };

  setTaggedStudents = taggedStudentsList => {
    this.setState({
      taggedStudentsForModal: taggedStudentsList,
    });
  };

  getAssessmentData = () => {
    const { item } = this.props;
    const assesmentData = _.find(
      item.items,
      item => _.get(item, "itemType", BLANK_STRING) === "STUDENT_ASSIGNMENT"
    );
    const assessmentItem = _.get(assesmentData, "item", BLANK_OBJECT);
    const studentData = _.get(assessmentItem, "student", BLANK_OBJECT);
    return {
      assesment: assessmentItem,
      student: studentData,
    };
  };

  onLETextClick = e => {
    const { item } = this.props;
    const {
      item: { id, resourceItem },
    } = this.props;

    const assesmentData = _.find(
      item.items,
      item => _.get(item, "itemType", BLANK_STRING) === "STUDENT_ASSIGNMENT"
    );
    const assessmentItem = _.get(assesmentData, "item", BLANK_OBJECT);
    const content = _.get(assessmentItem, "assignment.content", BLANK_OBJECT);
    const assessmentId = _.get(content, "id", BLANK_STRING);
    const isLETaggedAsResource = !_.isEmpty(resourceItem);
    if (!_.isEmpty(assesmentData)) this.onLEClick(id, assessmentId);
    else if (isLETaggedAsResource)
      this.onLEClick(id, _.get(resourceItem, "id", ""));
  };

  showCommentPane = () => {
    const {
      item: { id },
      onPostActionClick,
      staffEditAccess,
      isSidePaneContent,
    } = this.props;
    onPostActionClick({ id, action: "COMMENT", staffEditAccess });

    // open theatre mode if "x comments" is clicked from feed
    if (!isSidePaneContent) {
      this.openPostDetails();
      scrollIntoView({
        element: this.containerRef.current,
        block: "end",
        inline: "end",
      });
      return;
    }

    this.setState({
      showCommentBox: true,
      showViewAllComments: false,
      showCommentBar: true,
    });

    isSidePaneContent &&
      scrollIntoView({
        element: this.containerRef.current,
        block: "end",
        inline: "end",
      });
  };

  onPostSharingModalClose = () => {
    this.setState({ isSharingModalOpen: false });
  };

  onStudentResponseFnClick = () => {
    const {
      item: { id },
    } = this.props;
    this.onStudentResponseClick(id);
  };

  render() {
    const {
      item: {
        title,
        id,
        titleTranslationItem = {},
        createdBy,
        elementPYP,
        resourceItem,
        createdAt,
        publishedAt,
        students: { edges: taggedStudents },
        likes,
        seen,
        comments,
        attachments,
        state,
        isPrivate,
        isHiddenFromStudents,
        rejectComment,
        approveOrRejectBy,
        items,
        postTaggedEntity,
      },
      currentCommentPostId,
      onPostActionClick,
      onCloseClick,
      userId,
      userType,
      childName,
      studentId,
      isOpenedFromStudentPortfolio,
      canEditOrDelete,
      t,
      isArchivedClass,
      isSidePaneContent,
      isViewFromPostPage = false,
      mediaMaxWidth,
      theatreActiveAttachmentIndex,
      setTheatreAttachmentIndex,
      showAttachmentAsMediaCard = false,
      theatreActiveAttachmentId,
      setTheatreAttachmentById,
      showCloseBtn = true,
      canCreateComment,
      isRemovedCourseForLoggedInUser,
      isCurrentAcademicYearSelected,
      updatePostStatus,
      children,
      showCommentButton,
      filteredStudentActivities,
      fromPropsHandleActivitySelectedStudentAttachmentsChange,
      staffEditAccess = true,
      hideViews = false,
      hideLike = false,
      hideComments = false,
      hideLearninGoals,
      hideTaggedStudents,
      hideUnitDetails,
      showTaggedFolders,
      curriculumProgramId,
      canUserSeeRateLearningGoals,
      canDownloadMedia,
      isPostApprovalEnabled = true,
      getCurrentAssessmentTypes,
      cardType,
      toggleLEPreview,
      defaultStudentNameOrderPreference,
      currentChildId,
      defaultStudentIdentifierNamePreference,
      isUserAllowedToPublishPost,
      journalFilters,
      staffAccessPermission,
      hasManageAccessForStudentPortfolio,
      showRoutineDetails = false,
      isRoutinePost,
      filteredStudentRoutines,
      hasRoutinesManageAccess,
      useDSV2,
      commentContainerClass,
      postCardStyles,
      isViewFromUnitPlanReflection,
    } = this.props;

    const createdById = _.get(createdBy, "id");
    const firstName = _.get(createdBy, "firstName");
    const lastName = _.get(createdBy, "lastName");
    const middleName = _.get(createdBy, "middleName");
    const profileImage = _.get(createdBy, "profileImage");
    const createdByType = _.get(createdBy, "type");
    const {
      showMediaModal,
      activeIndex,
      showDownloadBeginOverlay,
      showTranslatedText,
      activitySelectedStudentId,
    } = this.state;

    const selectedActivityStudentIndex =
      !_.isEmpty(filteredStudentActivities) &&
      !_.isEmpty(activitySelectedStudentId)
        ? _.findIndex(
            filteredStudentActivities,
            activity =>
              _.get(activity, [
                "item",
                isRoutinePost ? "routineStudent" : "activityStudent",
                "id",
              ]) === activitySelectedStudentId
          )
        : -1;

    const activityId =
      selectedActivityStudentIndex !== -1
        ? _.get(
            filteredStudentActivities,
            [selectedActivityStudentIndex, "item", "id"],
            ""
          )
        : "";

    const activityType =
      selectedActivityStudentIndex !== -1
        ? _.get(
            filteredStudentActivities,
            [selectedActivityStudentIndex, "itemType"],
            ""
          )
        : "";

    const likesCount =
      selectedActivityStudentIndex !== -1
        ? _.get(
            filteredStudentActivities,
            [selectedActivityStudentIndex, "item", "likes", "totalCount"],
            0
          )
        : _.get(likes, "totalCount", 0);

    const commentsCount =
      selectedActivityStudentIndex !== -1
        ? _.get(
            filteredStudentActivities,
            [selectedActivityStudentIndex, "item", "comments", "totalCount"],
            0
          )
        : _.get(comments, "totalCount", 0);

    const unreadCommentsCount =
      selectedActivityStudentIndex !== -1
        ? _.get(
            filteredStudentActivities,
            [selectedActivityStudentIndex, "item", "comments", "unreadCountV2"],
            0
          )
        : -1;

    const activityAttachments =
      selectedActivityStudentIndex !== -1
        ? getSelectedStudentAttachments(
            _.get(
              isRoutinePost
                ? filteredStudentRoutines
                : filteredStudentActivities,
              [selectedActivityStudentIndex, "item"],
              BLANK_OBJECT
            ),
            isRoutinePost,
            _.get(this.props.item, "postTemplate.fields")
          )
        : [];

    const imageMaxWidth = _.isNil(mediaMaxWidth)
      ? isSidePaneContent
        ? 360
        : isViewFromPostPage
        ? 540
        : 600
      : mediaMaxWidth;

    const assesmentData = _.find(
      items,
      item => _.get(item, "itemType", "") === "STUDENT_ASSIGNMENT"
    );
    const assessmentItem = _.get(assesmentData, "item", BLANK_OBJECT);
    const itemType = _.get(assesmentData, "itemType", "");
    const content = _.get(assessmentItem, "assignment.content", BLANK_OBJECT);
    const assessmentType = _.get(content, "assessmentType.value", "");
    const assessmentId = _.get(content, "id", "");
    const studentData = _.get(assessmentItem, "student", BLANK_OBJECT);
    const isCommentOpen = currentCommentPostId == id;
    const isPublished = state == "PUBLISHED";

    const assessmentPostEntity = _.get(
      getTaggedAssessment(postTaggedEntity),
      "entity",
      BLANK_OBJECT
    );

    const isLETaggedAsResource =
      getIsNewGoalTaggingEnabled() && isAssessmentTagged(postTaggedEntity)
        ? !_.isEmpty(assessmentPostEntity)
        : !_.isEmpty(resourceItem);
    const isPostApproveRejectEnabled = _.isEqual(state, "REJECTED");

    const isPostUnderApproval =
      state == "IN_APPROVAL" &&
      ((userType != "staff" && !isSidePaneContent) || isViewFromPostPage);

    const studentResponseHasAudioAttachment =
      _.size(attachments) === 1 &&
      !_.isEmpty(assesmentData) &&
      !_.get(attachments, "[0].metadata.isWorksheetResponse", false);

    const hasAudioCaption =
      _.size(attachments) > 1 &&
      !_.isNil(_.find(attachments, attachment => attachment?.type == "AUDIO"));
    const attachmentContainer = classNames(
      { [classes.attachmentContainer]: true },
      { [classes.rejectedPost]: isPostApproveRejectEnabled },
      {
        [classes.paddingBottom]:
          hideLike === true && hideComments === true && hideViews === true,
      }
    );

    const titleTextContainer = classNames(
      { [classes.titleTextContainer]: true },
      {
        [classes.rejectedPost]: isPostApproveRejectEnabled,
      }
    );

    const studentResponseContainerClass = classNames({
      [classes.studentResponseContainer]: true,
      [classes.studentResponseContainerWithAudio]: studentResponseHasAudioAttachment,
    });

    const approvalContainer = classNames({
      [classes.postStatusBannerContainer]: true,
      [classes.approvalContainer]: true,
    });

    const textTitleClasses = classNames({
      [classes.titleText]: !isPortfolioRevampAndIsJournalRoute() && !useDSV2,
      [classes.titleTextV2]: isPortfolioRevampAndIsJournalRoute() || useDSV2,
      ["text-body"]: true,
    });

    const teacherFirstName = _.get(approveOrRejectBy, "firstName", "");
    const teacherLastName = _.get(approveOrRejectBy, "lastName", "");

    const assesmentStudentId = _.get(studentData, "id", 0);
    const studentImage = _.get(studentData, "profileImage", "");
    const isStudentOwnResponse = _.get(studentData, "id", "") === createdById;
    const currentAssessmentTypes = getCurrentAssessmentTypes();
    const LEAssessmentType = currentAssessmentTypes[assessmentType];
    const Icon = _.get(LEAssessmentType, "filledIcon") || CreateAssessmentSvg;
    const iconColor = _.get(
      LEAssessmentType,
      "filledIconColor",
      colors.blue400
    );
    const isVideo = _.get(attachments, "[0].type", "") === "VIDEO";
    // if isOnlyAudioAttachmentPresent is true, then display it in MediaPlaceholder
    // else display it in AttachmentList below TestMoreLess as it will be an audio caption

    const likedByFooterTextName =
      selectedActivityStudentIndex === -1
        ? _.get(likes, "edges[0].node.user.id", 0) == userId
          ? t("common:lowercase", { text: t("common:you") })
          : getFormattedUserName({
              user: _.get(likes, "edges[0].node.user", BLANK_OBJECT),
            })
        : _.get(
            filteredStudentActivities,
            [
              selectedActivityStudentIndex,
              "item",
              "likes",
              "edges",
              0,
              "node",
              "user",
              "id",
            ],
            0
          ) == userId
        ? t("common:lowercase", { text: t("common:you") })
        : getFormattedUserName({
            user: _.get(
              _.get(
                filteredStudentActivities,
                selectedActivityStudentIndex,
                BLANK_OBJECT
              ),
              "item.likes.edges.0.node.user",
              BLANK_OBJECT
            ),
          });

    const countTextDisplayed =
      _.get(likes, "totalCount", 0) > 0 ||
      _.get(comments, "totalCount", 0) > 0 ||
      _.get(seen, "totalCount", 0) > 0;
    const onLETextClick = e => {
      if (!_.isEmpty(assesmentData)) this.onLEClick(id, assessmentId);
      else if (isLETaggedAsResource) {
        this.onLEClick(
          id,
          _.get(
            getIsNewGoalTaggingEnabled() && isAssessmentTagged(postTaggedEntity)
              ? assessmentPostEntity
              : resourceItem,
            "id",
            ""
          )
        );
      }
    };

    const closeSeenLikeModal = () => {
      if (this.state.isLikesModalOpen)
        this.setState({ isLikesModalOpen: false });
      if (this.state.isViewsModalOpen)
        this.setState({ isViewsModalOpen: false });
    };

    const onCloseClickLocal = e => {
      e?.stopPropagation();
      if (_.isFunction(onCloseClick)) onCloseClick(e);
    };

    const showCommentPane = () => {
      const { isCurrentAcademicYearSelected, isArchivedClass } = this.props;
      if (!isCurrentAcademicYearSelected || isArchivedClass) return;
      onPostActionClick({ id, action: "COMMENT", staffEditAccess });

      // open theatre mode if "x comments" is clicked from feed
      if (!isSidePaneContent) {
        this.openPostDetails();
        scrollIntoView({
          element: this.containerRef.current,
          block: "end",
          inline: "end",
        });
        return;
      }

      this.setState({
        showCommentBox: true,
        showViewAllComments: false,
        showCommentBar: true,
      });

      isSidePaneContent &&
        scrollIntoView({
          element: this.containerRef.current,
          block: "end",
          inline: "end",
        });
    };

    const getAttachmentContainerStyles = () => {
      const styles = {};
      switch (state) {
        case "PUBLISHED":
          break;
        case "IN_APPROVAL":
        case "REJECTED":
          if (userType == "student") styles.paddingBottom = "0px";
          break;
        case "SCHEDULED":
          styles.paddingBottom = "0px";
          break;
      }

      return styles;
    };

    const isEditable =
      canEditOrDelete && (userType == "staff" || userId == createdById);

    let shouldShowCommentsInFeed = true;
    let shouldShowFooterComponent = false;
    shouldShowFooterComponent = true;
    shouldShowCommentsInFeed = isSidePaneContent;
    let shouldShowFooterText =
      _.size(filteredStudentActivities) < 2 && !isSidePaneContent;
    if (isSidePaneContent) {
      shouldShowFooterText = true;
    }

    const isJournalRoute = hasIncludeGivenPathInCurrentRoute({
      path: "/journal",
    });
    const isRoutineRoute =
      hasIncludeGivenPathInCurrentRoute({
        path: "/routines",
      }) && isRoutinesEnabled();
    const showPortfolioParityCard =
      isPortfolioParityEnabledAndIsJournalRoute() || isRoutineRoute;
    const fetchAudioAttachment = () => {
      return _.filter(attachments, { type: "AUDIO" });
    };

    if (
      isPortfolioReviewSetupEnabledAndIsJournalRoute() &&
      !isUserAllowedToPublishPost &&
      state === "IN_APPROVAL" &&
      journalFilters.state === "IN_APPROVAL_STAFF"
    ) {
      shouldShowFooterComponent = false;
    }
    if (hideLike === true && hideComments === true && hideViews === true)
      shouldShowFooterComponent = false;

    const getStudentTaggedInformation = () => {
      const isCreatedByStudent = createdByType === "student";
      const { currentChildId } = this.props;
      const excludeSelfFromStudents = _.filter(
        taggedStudents,
        item => !_.isEqual(_.get(item, "node.id"), createdById)
      );
      if (
        _.isEmpty(taggedStudents) ||
        (isCreatedByStudent && _.isEmpty(excludeSelfFromStudents))
      ) {
        return {};
      }
      const formatStudent = student => {
        return {
          id: _.get(student, "id"),
          value: getFormattedUserNameWithoutPronoun({
            user: student,
          }),
          imageUrl: _.get(student, "profileImage", null),
        };
      };
      if (userType == "staff") {
        return _.size(taggedStudents, 0) > 0
          ? isCreatedByStudent
            ? formatStudent(
                _.get(this.props.item, "students.edges[1].node", {})
              )
            : formatStudent(
                _.get(this.props.item, "students.edges[0].node", {})
              )
          : {};
      } else if (
        _.get(this.props, "showAllStudentsInFilter") ||
        userType === "parent"
      ) {
        if (_.size(taggedStudents, 0) > 0) {
          const excludeSelfFromStudents = _.filter(
            taggedStudents,
            item => !_.isEqual(_.get(item, "node.id"), createdById)
          );
          if (isCreatedByStudent && userType !== "parent") {
            return createdById ===
              (userType !== "parent" ? userId : currentChildId)
              ? formatStudent(_.get(excludeSelfFromStudents, "[0].node"))
              : formatStudent(
                  _.find(
                    excludeSelfFromStudents,
                    item =>
                      _.get(item, "node.id") ===
                      (userType !== "parent" ? userId : currentChildId)
                  )?.node
                );
          }
          if (isCreatedByStudent && userType === "parent") {
            return {};
          }
          return formatStudent(
            _.find(
              taggedStudents,
              item =>
                _.get(item, "node.id") ===
                (userType !== "parent" ? userId : currentChildId)
            )?.node || _.first(taggedStudents)?.node
          );
        }
      } else {
        return formatStudent(
          _.find(
            taggedStudents,
            item =>
              _.get(item, "node.id") ===
              (userType !== "parent" ? userId : currentChildId)
          )?.node
        );
      }
    };

    const getPostCreatorName = _.memoize((firstName, lastName, middleName) => {
      return { firstName, lastName, middleName };
    });

    const audioFileDownload = attachment => {
      const { downloadFromUrl, removeProgressElement } = this.props;
      let name = _.get(attachment, "name", "");
      if (_.isEmpty(name)) {
        name = "toddle_audio_" + moment().format("DD-MM-YY_h_mm");
      }

      const id = "Toddle_audio_#123";

      downloadFromUrl({
        name: name,
        attachment: attachment,
        shouldAskForSave: true,
        fileUploadId: id,
      }).then(() => {
        removeProgressElement({ id });
      });
    };

    const getTitleValue = title => {
      return !(_.isEqual(title, "null") || _.isEqual(title, "undefined"))
        ? title
        : "";
    };

    const textMoreButtonProps = {
      dsVersion: "2.0",
      variant: "progressive",
      type: "inline",
    };

    const isRnpEnabled = ACLStore.can(ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION);

    const hasManageAccess = getHasManageAccess({
      userType,
      isRnpEnabled,
      hasManageAccessForStudentPortfolio,
      hasRoutinesManageAccess,
    });
    const dsV2Props = {};
    if (useDSV2) {
      dsV2Props["dsVersion"] = "2.0";
      dsV2Props["type"] = "plain";
      dsV2Props["variant"] = "neutral";
      dsV2Props["size"] = "medium";
    }

    return this.shouldHidePostCardToFamily({
      assessment: assessmentItem,
      curriculumProgramId,
      userType,
    }) ? null : (
      <>
        <div
          className={classes.container}
          style={{
            ...(this.props.containerStyle || {}),
            ...(!this.props.isSidePaneContent
              ? style.largeCardContainerStyle
              : {
                  ...style.smallCardContainerStyle,
                  ..._.get(
                    this.props,
                    "dynamicSmallCardContainerStyle",
                    BLANK_OBJECT
                  ),
                  ...(isPublished &&
                    showCommentButton &&
                    style.stickyCommentStyle(showNewTheatreMode())),
                }),
          }}
          data-test-id="journal-feed-postcard"
        >
          {this.state.isSharingModalOpen && (
            <PostSharedWithModal
              isModalOpen={this.state.isSharingModalOpen}
              closeSharingModal={this.onPostSharingModalClose}
              post={this.props.item}
              taggedStudents={this.state.taggedStudentsForModal}
              isPrivate={isPrivate}
              isHiddenFromStudents={isHiddenFromStudents}
              t={t}
              {...(isRoutinePost ? { dsVersion: "2.0" } : {})}
            />
          )}
          {isPostApproveRejectEnabled && !isSidePaneContent && (
            <div className={classes.postStatusBannerContainer}>
              <div className={classes.rejectTextContainer}>
                <span className={classes.rejectText}>
                  {t("journal:teacher_returned_for_review", {
                    label: `${teacherFirstName} ${teacherLastName}`,
                  })}
                </span>
              </div>
              {!_.isEmpty(rejectComment) && (
                <div className={classes.rejectCommentContainer}>
                  <div className={classes.rejectCommentIcon}>
                    <CommentRemarkOutlined />
                  </div>
                  <span className={classes.rejectCommentText}>
                    {rejectComment}
                  </span>
                </div>
              )}
            </div>
          )}
          {isPostUnderApproval && (
            <div
              className={approvalContainer}
              style={
                isSidePaneContent ? style.approvalContainerStyle : BLANK_OBJECT
              }
            >
              {t("journal:waiting_teacher_approval")}
            </div>
          )}
          {
            // Hide top banner having assessment title
            !_.isEmpty(assesmentData) && false && (
              <div className={classes.leContainer}>
                <span className={classes.leInnerContainer}>
                  <div
                    className={classes.assessmentContainer}
                    onClick={() => this.onLEClick(id, assessmentId)}
                  >
                    <div className={classes.leIconContainer}>
                      <Icon
                        width={20}
                        height={20}
                        fill={iconColor}
                        fill1={colors.white}
                      />
                    </div>
                    <div className={classes.assessmentTitle}>
                      {_.get(content, "title.value", "")}
                    </div>
                  </div>
                </span>
              </div>
            )
          }
          <div
            className={classes.createdByWrapper}
            onClick={this.openPostDetails}
            data-test-id="journal-feed-postcard-header"
          >
            <div
              className={classes.createdByContainer}
              style={postCardStyles?.createdByContainerStyles}
            >
              <div className={classes.createdByLeftContainer}>
                <DualProfile
                  shape={
                    isPortfolioRevampAndIsJournalRoute() || useDSV2
                      ? "square"
                      : "circle"
                  }
                  user1={{
                    id: createdById,
                    value: getFormattedUserName({
                      user: createdBy,
                    }),
                    imageUrl: profileImage,
                  }}
                  user2={
                    (!_.isEmpty(filteredStudentActivities) &&
                      !isSidePaneContent) ||
                    (isSidePaneContent &&
                      _.size(filteredStudentActivities) === 1)
                      ? {
                          id: _.get(
                            filteredStudentActivities,
                            isRoutinePost
                              ? "0.item.routineStudent.id"
                              : "0.item.activityStudent.id",
                            ""
                          ),
                          value: getFormattedUserNameWithoutPronoun({
                            user: _.get(filteredStudentActivities, [
                              "0",
                              "item",
                              isRoutinePost
                                ? "routineStudent"
                                : "activityStudent",
                            ]),
                          }),
                          imageUrl: _.get(
                            filteredStudentActivities,
                            isRoutinePost
                              ? "0.item.routineStudent.profileImage"
                              : "0.item.activityStudent.profileImage",
                            ""
                          ),
                        }
                      : _.isEmpty(studentData) || isStudentOwnResponse
                      ? isPortfolioParityEnabled() &&
                        isSidePaneContent &&
                        !_.isEmpty(getStudentTaggedInformation())
                        ? getStudentTaggedInformation()
                        : BLANK_OBJECT
                      : {
                          id: assesmentStudentId,
                          value: getFormattedUserNameWithoutPronoun({
                            user: studentData,
                          }),
                          imageUrl: studentImage,
                        }
                  }
                  showNewDesign={isPortfolioParityEnabledAndIsJournalRoute()}
                  cascadeProfileStyle={
                    isPortfolioRevampAndIsJournalRoute() || useDSV2
                      ? style.cascadeProfileStyle
                      : BLANK_OBJECT
                  }
                />
                <TaggedText
                  t={t}
                  postId={id}
                  taggedStudents={taggedStudents}
                  elementPYP={elementPYP}
                  createdByName={getFormattedUserName({
                    user: createdBy,
                  })}
                  attachments={attachments}
                  date={
                    isPublished || state == "SCHEDULED"
                      ? publishedAt
                      : createdAt
                  }
                  isPrivate={isPrivate}
                  isHiddenFromStudents={isHiddenFromStudents}
                  userType={userType}
                  childName={childName}
                  studentId={studentId}
                  isOpenedFromStudentPortfolio={isOpenedFromStudentPortfolio}
                  isStudentResponse={!_.isEmpty(assesmentData)}
                  isStudentOwnResponse={isStudentOwnResponse}
                  isLETaggedAsResource={isLETaggedAsResource}
                  LEResource={
                    getIsNewGoalTaggingEnabled() &&
                    isAssessmentTagged(postTaggedEntity)
                      ? assessmentPostEntity
                      : resourceItem
                  }
                  assesmentData={this.getAssessmentData()}
                  onLEtextClick={this.onLETextClick}
                  setSharingModalVisibility={this.setSharingModalVisibility}
                  setTaggedStudents={this.setTaggedStudents}
                  isSidePaneContent={isSidePaneContent}
                  canOpenLEPreview={this.canOpenLEPreview()}
                  activityStudents={filteredStudentActivities}
                  state={state}
                  toggleLEPreview={toggleLEPreview}
                  assessmentId={
                    _.get(
                      getIsNewGoalTaggingEnabled() &&
                        isAssessmentTagged(postTaggedEntity)
                        ? assessmentPostEntity
                        : resourceItem,
                      "id",
                      ""
                    ) || assessmentId
                  }
                  defaultStudentNameOrderPreference={
                    defaultStudentNameOrderPreference
                  }
                  currentUserId={userId}
                  createdById={createdById}
                  showAllStudentsInFilter={_.get(
                    this.props,
                    "showAllStudentsInFilter"
                  )}
                  currentChildId={currentChildId}
                  defaultStudentIdentifierNamePreference={
                    defaultStudentIdentifierNamePreference
                  }
                  isRoutinePost={this.props.isRoutinePost}
                  useDSV2={useDSV2}
                />
              </div>
              <div
                className={classes.moreIconContainer}
                style={postCardStyles?.moreIconContainerStyles}
              >
                {/* cardType === small is used to show only edit button inside evidence screen theatre mode */}
                {canEditOrDelete &&
                  hasManageAccess &&
                  cardType !== "small" &&
                  !isViewFromPostPage &&
                  !isViewFromUnitPlanReflection && (
                    <DropDown
                      userType={userType}
                      id={id}
                      onPostActionClick={onPostActionClick}
                      createdByType={createdByType}
                      isArchivedClass={isArchivedClass}
                      isAddLEToJournal={_.isEqual(
                        itemType,
                        "STUDENT_ASSIGNMENT"
                      )}
                      postState={state}
                      showNewDropdown={true}
                      studentActivityType={
                        !_.isEmpty(filteredStudentActivities)
                          ? _.get(
                              _.first(filteredStudentActivities),
                              "item.activityType"
                            )
                          : undefined
                      }
                      isPostApprovalEnabled={isPostApprovalEnabled}
                      onCloseClick={onCloseClick}
                      toggleMediaModal={this.toggleMediaModal}
                      isSidePaneContent={isSidePaneContent}
                      openedFromNotification={_.get(
                        this.props,
                        "openedFromNotification",
                        false
                      )}
                      createdById={_.get(createdBy, "id")}
                      isUserAllowedToPublishPost={_.includes(
                        staffAccessPermission,
                        "PUBLISH"
                      )}
                    />
                  )}
                {isSidePaneContent &&
                isEditable &&
                cardType === "small" &&
                !isViewFromPostPage ? (
                  <IconButton
                    icon={<PencilOutlined />}
                    onClick={this.onEditPostClick}
                    variant="plain"
                    size="medium"
                    testId="postcard-edit"
                    {...dsV2Props}
                  />
                ) : null}
                {isSidePaneContent && showCloseBtn && (
                  <div style={{ margin: "0 8px" }}>
                    <IconButton
                      icon={<CloseOutlined />}
                      onClick={onCloseClickLocal}
                      variant="plain"
                      size={"x-small"}
                      testId="postcard-close"
                      {...dsV2Props}
                    />
                  </div>
                )}
              </div>
            </div>
            {getTitleValue(title) && (
              <div className={titleTextContainer}>
                <div className={textTitleClasses}>
                  <TextMoreLessV2
                    value={
                      showTranslatedText
                        ? getTitleValue(this.state.titleText)
                        : getTitleValue(title)
                    }
                    minHeight={222}
                    lineClamp={14}
                    testId="journal-feed-postcard-title"
                    buttonProps={textMoreButtonProps}
                  />
                </div>
              </div>
            )}
          </div>
          {!_.isEmpty(filteredStudentActivities) && !isRoutinePost ? (
            isSidePaneContent ? (
              <StudentActivityDetail
                studentActivities={filteredStudentActivities}
                activitySelectedStudentId={this.state.activitySelectedStudentId}
                handleActivitySelectedStudentAttachmentsChange={
                  fromPropsHandleActivitySelectedStudentAttachmentsChange
                }
                theatreActiveAttachmentIndex={theatreActiveAttachmentIndex}
                setTheatreAttachmentIndex={setTheatreAttachmentIndex}
                handleActivitySelectedStudentIdChange={
                  this.handleActivitySelectedStudentIdChange
                }
                defaultStudentNameOrderPreference={
                  defaultStudentNameOrderPreference
                }
              />
            ) : (
              <StudentActivities
                studentActivities={filteredStudentActivities}
                isSidePaneContent={isSidePaneContent}
                handleActivitySelectedStudentChange={
                  this.handleActivitySelectedStudentChange
                }
                onMediaClick={this.onMediaClick}
                defaultStudentNameOrderPreference={
                  defaultStudentNameOrderPreference
                }
              />
            )
          ) : null}

          {/* RoutineDetails */}
          {isSidePaneContent &&
          (showRoutineDetails ||
            (isRoutinePost && _.size(this.props.filteredStudentRoutines))) ? (
            <StudentRoutineDetails
              isSidePaneContent={isSidePaneContent}
              taggedStudents={taggedStudents}
              filteredStudentRoutines={this.props.filteredStudentRoutines}
              postTemplateFields={_.get(this.props.item, "postTemplate.fields")}
              selectedRoutineStudentId={this.state.activitySelectedStudentId}
              fromPropsHandleActivitySelectedStudentAttachmentsChange={
                fromPropsHandleActivitySelectedStudentAttachmentsChange
              }
              handleActivitySelectedStudentAttachmentsChange={
                this.handleActivitySelectedStudentAttachmentsChange
              }
              handleActivitySelectedStudentIdChange={
                this.handleActivitySelectedStudentIdChange
              }
              theatreActiveAttachmentIndex={theatreActiveAttachmentIndex}
              setTheatreAttachmentIndex={setTheatreAttachmentIndex}
              userType={userType}
              studentId={studentId}
              hasAttachments={
                _.size(activityAttachments) || _.size(this.state.attachments)
              }
            />
          ) : null}
          <div
            className={attachmentContainer}
            style={getAttachmentContainerStyles()}
          >
            {!_.isEmpty(assesmentData) ? (
              <div className={studentResponseContainerClass}>
                {studentResponseHasAudioAttachment && (
                  <MediaPlaceholder
                    attachments={attachments}
                    hasAudioCaption={true}
                    containerStyle={style.mediaPlaceHolderContainerStyle}
                    showFileName={false}
                    showAudioDownloadButton={canDownloadMedia}
                  />
                )}
                <StudentResponseV2
                  item={assessmentItem}
                  post={this.props?.item}
                  postIdFromParent={
                    _.get(this.props, "sourceType") == "PUBLIC_URL"
                      ? _.get(this.props, "params.postId")
                      : undefined
                  }
                  workSheetPostAttachments={
                    _.get(
                      this.props?.item,
                      "resourceItem.assessmentType.value"
                    ) === "worksheet" ||
                    (isAssessmentTagged(
                      _.get(this.props?.item, "postTaggedEntity")
                    ) &&
                      _.get(
                        _.first(_.get(this.props?.item, "postTaggedEntity")),
                        "entity.assessmentType.value"
                      ) === "worksheet")
                      ? attachments
                      : BLANK_ARRAY
                  }
                  isPostFeed={true}
                  showSeeMore={true}
                  containerStyle={style.containerStyle}
                  horizontalCardStyle={style.horizontalCardStyle}
                  showEvaluation={true}
                  onClickResponse={this.onStudentResponseFnClick}
                  isPreviewCard={true}
                  isSidePaneContent={this.props.isSidePaneContent}
                  canUserSeeRateLearningGoals={canUserSeeRateLearningGoals}
                  setTheatreAttachmentIndex={setTheatreAttachmentIndex}
                  theatreActiveAttachmentId={theatreActiveAttachmentId}
                  setTheatreAttachmentById={setTheatreAttachmentById}
                  showTheatreModeOnInit={
                    showNewTheatreMode() ? showMediaModal : false
                  } // opens theatre mode of StudentResponseV2 directly.
                  toggleParentMediaModalState={this.toggleParentMediaModalState}
                  canCreateComment={canCreateComment}
                  postViewMode={
                    isRemovedCourseForLoggedInUser ||
                    isArchivedClass ||
                    !isCurrentAcademicYearSelected
                      ? "view"
                      : "edit"
                  } // disabling liking post and comment actions in view mode
                  onPostActionClick={this.onPostActionClick}
                  hideLike={hideLike}
                  hideViews={hideViews}
                  hideComments={hideComments}
                  hideLearninGoals={hideLearninGoals}
                  hideTaggedStudents={hideTaggedStudents}
                  hideUnitDetails={hideUnitDetails}
                  showTaggedFolders={showTaggedFolders}
                  postRatedLearningGoalsDetails={
                    postRatedLearningGoalsDetailsBase
                  }
                  taggedStudents={taggedStudents}
                  isViewFromPostPage={isViewFromPostPage}
                  canEditOrDelete={canEditOrDelete}
                />
              </div>
            ) : _.get(attachments, "length", 0) > 0 ? (
              !showAttachmentAsMediaCard ? (
                <MediaPlaceholder
                  attachments={attachments}
                  imageMaxWidth={imageMaxWidth}
                  itemStyles={{
                    borderRadius: "8px",
                    width: "100%",
                    maxWidth: "536px",
                  }}
                  iconContainerStyle={{ width: "12%" }}
                  onClickMedia={this.onMediaClick}
                  hasAudioCaption={hasAudioCaption}
                  audioCaptionContainerStyles={{
                    padding: isSidePaneContent
                      ? "0px 16px 16px 16px"
                      : "0px 0px 12px",
                  }}
                  showOverlayIcons={false}
                  showMiddleContainerIcons={isVideo}
                  showDownloadBeginOverlay={showDownloadBeginOverlay}
                  getEmbedPlayerRef={this.updateEmbedPlayerRef}
                  showCarouselV2={true}
                  showFileName={false}
                  showIconCardsWithExtension={true}
                  showExtensionOnCornerByHover={true}
                  showAudioDownloadButton={canDownloadMedia}
                  noteContainerStyle={{ padding: "0px", maxWidth: "536px" }}
                />
              ) : (
                <div className={classes.attachmentMediaCardsContainer}>
                  {showPortfolioParityCard &&
                    _.map(fetchAudioAttachment(), attachment => (
                      <div className={classes.audioCard}>
                        <AudioWaveformPlayer
                          attachment={attachment}
                          audioLoaded={_.noop}
                        />
                        <span
                          style={{
                            alignSelf: "center",
                            display: "flex",
                            aliginItem: "center",
                          }}
                        >
                          <IconButton
                            icon={<DownloadOutlined />}
                            variant="plain"
                            size="small"
                            onClick={() => {
                              audioFileDownload(attachment);
                            }}
                          />
                        </span>
                      </div>
                    ))}
                  {_.map(
                    showPortfolioParityCard
                      ? _.filter(
                          attachments,
                          attachment => attachment.type !== "AUDIO"
                        )
                      : attachments,
                    (attachment, index) => {
                      const attachmentType = _.get(attachment, "type", "FILE");
                      const isToddleDoc = attachmentType === "TODDLE_DOC";
                      const name = _.isEqual(attachmentType, "NOTE")
                        ? _.get(attachment, "title", "untitled")
                        : _.get(attachment, "name.length")
                        ? _.get(attachment, "name", "untitled")
                        : t("common:recording");
                      const mimeType = _.get(attachment, "mimeType", "");
                      const thumbUrl = isToddleDoc
                        ? undefined
                        : attachmentType == "IMAGE"
                        ? _.get(attachment, "url", "")
                        : _.get(attachment, "thumbUrl", "");

                      const url = _.get(attachment, "url", "");
                      const subText = isToddleDoc
                        ? t("classRoom:toddle_doc_capitalized")
                        : undefined;

                      return (
                        <div
                          tabIndex={0}
                          className={classes.mediaCard}
                          key={`ATTACHMENT_${_.get(attachment, "id", "")}`}
                          style={{ marginBottom: "8px" }}
                          onKeyDown={this.onMediaCardKeydown(index)}
                        >
                          <MediaCard
                            cardType="medium"
                            name={name}
                            type={isToddleDoc ? "TODDLE-DOC" : attachmentType}
                            mimeType={mimeType}
                            thumbUrl={thumbUrl}
                            url={url}
                            showSubtext={true}
                            isActivated={
                              _.get(attachment, "id", "") ==
                              theatreActiveAttachmentId
                            }
                            onClick={() =>
                              this.onMediaClick({ activeIndex: index })
                            }
                            style={{ marginBottom: "8px" }}
                            testId="journal-feed-postcard-mediacard"
                            subtext={subText}
                          />
                        </div>
                      );
                    }
                  )}
                </div>
              )
            ) : (
              <div></div>
              // <div className={classes.noAttachment}>
              //   {t("common:noAttachment")}
              // </div>
            )}
          </div>
          <ModelContent
            attachments={
              !_.isEmpty(filteredStudentActivities) &&
              !_.isEmpty(this.state.activitySelectedStudentId)
                ? _.get(this.props, "openedFromNotification", false)
                  ? activityAttachments
                  : this.state.attachments
                : this.state.attachments
            }
            isStudentResponse={!_.isEmpty(assesmentData)}
            toggleMediaModal={this.toggleMediaModal}
            showMediaModal={showMediaModal}
            activeIndex={activeIndex}
            toggleDownloadBeginOverlay={this.toggleDownloadBeginOverlay}
            post={this.props?.item}
            curriculumProgramType={this.props?.curriculumProgramType}
            t={t}
            canCreateComment={canCreateComment}
            postViewMode={
              isRemovedCourseForLoggedInUser ||
              isArchivedClass ||
              !isCurrentAcademicYearSelected
                ? "view"
                : "edit"
            } // disabling liking post and comment actions in view mode
            updatePostStatus={updatePostStatus}
            onPostActionClick={this.onPostActionClick}
            onPostSidePaneCloseClick={onCloseClick}
            fromPropsActivitySelectedStudentId={
              this.state.activitySelectedStudentId
            }
            fromPropsHandleActivitySelectedStudentChange={
              this.handleActivitySelectedStudentChange
            }
            fromPropsHandleActivitySelectedStudentAttachmentsChange={
              this.handleActivitySelectedStudentAttachmentsChange
            }
            staffEditAccess={staffEditAccess}
            hideLike={hideLike}
            hideViews={hideViews}
            hideComments={hideComments}
            hideLearninGoals={hideLearninGoals}
            hideTaggedStudents={hideTaggedStudents}
            hideUnitDetails={hideUnitDetails}
            showTaggedFolders={showTaggedFolders}
            taggedStudents={taggedStudents}
            showPostLearningGoals={_.get(
              this.props,
              "showPostLearningGoals",
              true
            )}
            canDownloadMedia={canDownloadMedia}
            sourceType={_.get(this.props, "sourceType", BLANK_STRING)}
            paramPostId={_.get(this.props, "params.postId", BLANK_STRING)}
            isViewFromPostPage={isViewFromPostPage}
            openedFromNotification={_.get(
              this.props,
              "openedFromNotification",
              false
            )}
            canEditOrDelete={canEditOrDelete}
            postRatedLearningGoalsDetailsBase={
              postRatedLearningGoalsDetailsBase
            }
            useDSV2={useDSV2}
            postCardStyles={postCardStyles}
            isViewFromUnitPlanReflection={isViewFromUnitPlanReflection}
            learningCourseIdFromProps={_.get(
              this.props.item,
              "course.learningCourse[0].id",
              null
            )}
          />
          {showPortfolioParityCard && _.size(this.props?.item?.folders) > 0 ? (
            <div
              className={classes.subDetailContainer}
              style={style.foldersSubDetailContainer}
            >
              <TaggedFoldersV2
                folders={this.props?.item.folders}
                showFolderIcon={true}
                isClosable={false}
              />
            </div>
          ) : null}
          {shouldShowFooterComponent ? (
            <div
              className={classes.cardFooterContainer}
              style={{
                paddingBottom: isSidePaneContent ? "16px" : "0px",
                gap: showPortfolioParityCard ? "0px" : "",
              }}
            >
              {state == "PUBLISHED" &&
              shouldShowFooterText &&
              !showPortfolioParityCard ? (
                <FooterText
                  showLike={_.isNil(hideLike) ? true : !hideLike}
                  likesCount={likesCount}
                  showComment={_.isNil(hideComments) ? true : !hideComments}
                  commentsCount={commentsCount}
                  viewsCount={_.get(seen, "totalCount", 0)}
                  likedByName={likedByFooterTextName}
                  t={t}
                  showViews={
                    userType === "staff" &&
                    (_.isNil(hideViews) ? true : !hideViews)
                  }
                  toggleLikeModal={this.toggleLikeModal}
                  toggleViewsModal={this.toggleViewsModal}
                  showCommentsPane={this.showCommentPane}
                  userType={userType}
                />
              ) : null}
              <FooterButtons
                staffEditAccess={staffEditAccess}
                userType={userType}
                id={id}
                showLikeButton={_.isNil(hideLike) ? true : !hideLike}
                likes={
                  selectedActivityStudentIndex !== -1
                    ? _.size(filteredStudentActivities) > 1 &&
                      !isSidePaneContent
                      ? null
                      : _.get(
                          filteredStudentActivities,
                          [selectedActivityStudentIndex, "item", "likes"],
                          BLANK_OBJECT
                        )
                    : _.get(this.props, "item.likes", BLANK_OBJECT)
                }
                showCommentButton={_.isNil(hideComments) ? true : !hideComments}
                comments={
                  selectedActivityStudentIndex !== -1
                    ? _.get(
                        filteredStudentActivities,
                        [selectedActivityStudentIndex, "item", "comments"],
                        BLANK_OBJECT
                      )
                    : _.get(this.props, "item.comments", BLANK_OBJECT)
                }
                seenCount={_.get(seen, "totalCount", 0)}
                state={state}
                userId={userId}
                isCommentOpen={isCommentOpen}
                onPostActionClick={this.onPostActionClick}
                canEditOrDelete={canEditOrDelete}
                createdByType={createdByType}
                t={t}
                createdByName={
                  _.isEqual(createdByType, "student")
                    ? getStudentIdentifierName({
                        student: getPostCreatorName(
                          firstName,
                          lastName,
                          middleName
                        ),
                        defaultStudentIdentifierNamePreference,
                      })
                    : firstName
                }
                isArchivedClass={isArchivedClass}
                isAddLEToJournal={_.isEqual(itemType, "STUDENT_ASSIGNMENT")}
                isSidePaneContent={isSidePaneContent}
                showTranslationButton={
                  hasTranslationPermission() &&
                  _.get(titleTranslationItem, "showTranslate", false)
                }
                showTranslatedText={showTranslatedText}
                toggleTranslatedText={this.toggleTranslatedText}
                setTitleText={this.setTitleText}
                isViewFromPostPage={isViewFromPostPage}
                showLikeCount={true}
                showCommentCount={true}
                countTextDisplayed={countTextDisplayed}
                isPostTypeActivity={!_.isEmpty(filteredStudentActivities)}
                hasManageAccessForStudentPortfolio={hasManageAccess}
                isRoutinePost={isRoutinePost}
                hasRoutinesManageAccess={
                  userType === "staff"
                    ? hasRoutinesManageAccess ||
                      canManageRoutineActions(userType)
                    : true
                }
                useDSV2={useDSV2}
              />
            </div>
          ) : null}
          {state == "PUBLISHED" &&
          shouldShowFooterText &&
          showPortfolioParityCard ? (
            <FooterText
              showLike={_.isNil(hideLike) ? true : !hideLike}
              likesCount={likesCount}
              showComment={_.isNil(hideComments) ? true : !hideComments}
              commentsCount={commentsCount}
              viewsCount={_.get(seen, "totalCount", 0)}
              likedByName={likedByFooterTextName}
              t={t}
              showViews={
                userType === "staff" && (_.isNil(hideViews) ? true : !hideViews)
              }
              toggleLikeModal={this.toggleLikeModal}
              toggleViewsModal={this.toggleViewsModal}
              showCommentsPane={showCommentPane}
              userType={userType}
              showNewDesign={true}
              isSidePaneContent={isSidePaneContent}
            />
          ) : null}
          {children}
          {!hideComments &&
          shouldShowFooterComponent &&
          shouldShowCommentsInFeed ? (
            <div>
              {isSidePaneContent && commentsCount > 0 ? (
                <div className={classes.separator} />
              ) : null}
              <div
                className={classes.commentsContainer}
                ref={this.containerRef}
                style={{ paddingTop: commentsCount > 0 ? "16px" : "0px" }}
              >
                <CardCommentsV2
                  parentId={
                    !_.isEmpty(activityId) ? activityId : this.props?.item?.id
                  }
                  parentType={!_.isEmpty(activityType) ? activityType : "POST"}
                  postDetails={this.props?.item}
                  showCommentBox={this.state.showCommentBox && isPublished}
                  canPublishComment={isPublished && showCommentButton}
                  commentBoxRef={this.commentBoxRef}
                  canComment={
                    isPublished &&
                    staffEditAccess &&
                    canCreateComment &&
                    hasManageAccess
                  }
                  canDelete={staffEditAccess && hasManageAccess}
                  showViewAllComments={
                    !isSidePaneContent && this.state.showViewAllComments
                  }
                  isSidePaneContent={this.props.isSidePaneContent}
                  containerRef={this.containerRef}
                  editSidePaneComment={this.onEditComment}
                  editComment={this.state.commentToEdit}
                  refetchComment={this.state.refetchComment}
                  setRefetchComment={this.setRefetchComment}
                  setCommentBar={this.setCommentBar}
                  showCommentBar={this.state.showCommentBar}
                  commentsFromProps={
                    selectedActivityStudentIndex !== -1
                      ? _.get(
                          filteredStudentActivities,
                          [
                            selectedActivityStudentIndex,
                            "item",
                            "comments",
                            "edges",
                          ],
                          []
                        )
                      : _.get(this.props, "item.comments.edges", [])
                  }
                  totalCount={commentsCount}
                  unreadCount={unreadCommentsCount}
                  cacheVariables={commentCacheVariables}
                  postFragment={PostCommentFragment}
                  hideCommentBar={this.hideCommentBar}
                  hasManageAccessForStudentPortfolio={hasManageAccess}
                  hasAttachments={
                    _.size(activityAttachments) ||
                    _.size(this.state.attachments)
                  }
                  addPaddingTopFromChatbarWrapper={
                    !_.includes(
                      window.location.href,
                      "/family-portfolio-summary"
                    )
                  }
                  hasRoutinesManageAccess={hasRoutinesManageAccess}
                  commentContainerClass={commentContainerClass}
                />
              </div>
            </div>
          ) : null}
        </div>
        {(this.state.isLikesModalOpen || this.state.isViewsModalOpen) && (
          <PostSeenLikeModal
            isModalOpen={
              this.state.isLikesModalOpen || this.state.isViewsModalOpen
            }
            closeSeenLikeModal={closeSeenLikeModal}
            postId={this.props?.item?.id}
            activityId={activityId}
            postType={
              !_.isEmpty(activityType)
                ? activityType
                : _.size(this.props.filteredStudentRoutines) && isRoutinePost
                ? "STUDENT_TEMPLATE_RESPONSE"
                : "POST"
            }
            showLikes={this.state.isLikesModalOpen}
            showViews={this.state.isViewsModalOpen}
            t={t}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const userInfo = getUserInfo();
  const academicYearId = getSelectedAcademicYearId(state);

  const isRemovedCourseForLoggedInUser = _.get(
    getCourseDetailsFromCache({
      id: _.get(state, "teacher.selected_class.selected_course"),
      courseGradeFilters: { academicYearId },
    }),
    "isRemovedCourseForLoggedInUser",
    false
  );

  const isArchivedClass = _.get(
    state,
    "teacher.selected_class.isArchivedClass"
  );
  const isCurrentAcademicYearSelected = _.get(
    state,
    "platform.academicYearSelected.isCurrentAcademicYear",
    true
  );
  const canCreateComment =
    (!isRemovedCourseForLoggedInUser &&
      !isArchivedClass &&
      isCurrentAcademicYearSelected &&
      _.get(ownProps, "canCreateComment", true)) ||
    isRoutinesRoute();

  const userType = state.login.userInfo.user_type;
  const { courseIdFromQuery } = ownProps;
  const courseId = state.teacher.selected_class.selected_course;
  const defaultStudentNameOrderPreference = getDefaultStudentNameOrderPreference(
    state
  );

  const showCommentButton =
    userType === "staff" ||
    (getSettingValue({
      name:
        userType === "parent"
          ? "enableFamilyCommentCreation"
          : "EnableCommentingOnPostByStudents",
      courseId: courseIdFromQuery ? courseIdFromQuery : courseId,
      organizationId: userInfo.org_id,
      userId: userInfo.id,
      userEntityType: userInfo.userEntityType,
    }) &&
      canCreateComment) ||
    isRoutinesRoute();

  const studentId =
    userInfo.childID || ownProps?.portfolioStudentId || userInfo.id;

  const studentActivities = fetchStudentActivitiesMemoized({
    items: _.get(ownProps, "item.items", []),
  });

  const studentRoutines = fetchStudentRoutinesMemoized({
    items: _.get(ownProps, "item.items", []),
  });

  const filteredStudentActivities = fetchfilteredStudentActivities(
    studentActivities,
    userType,
    studentId
  );

  const filteredStudentRoutines = fetchfilteredStudentRoutines(
    studentRoutines,
    userType,
    studentId
  );

  // learning goals tagged on assessment
  const canUserSeeRateLearningGoals =
    userType != "parent" ||
    (userType == "parent" &&
      getSettingValue({
        name: "FamilyCanViewEvaluation",
        currentCurriculumProgramId: getSelectedCurriculumId(state),
      }));

  // learning goals tagged on post
  const showPostLearningGoals =
    userType !== "parent"
      ? true
      : getSettingValue({
          name: "ShowPypElementInFamilyApp",
          currentCurriculumProgramId: getSelectedCurriculumId(state),
        });

  // show donwload button in theatre mode
  const canDownloadMedia =
    userType != "parent" ||
    (userType == "parent" &&
      getSettingValue({
        name: "FamilyCanDownloadMedia",
        currentCurriculumProgramId: getSelectedCurriculumId(state),
      }));

  // setting for post approval required is ON or OFF
  const isPostApprovalEnabled = getSettingValue({
    name: "EnablePostApprovalRequiredForNewStudents",
    courseId: state.teacher.selected_class.selected_course,
    organizationId: state.login.userInfo.org_id,
    userId: state.login.userInfo.id,
    userEntityType: state.login.userInfo.userEntityType,
  });

  const showAllStudentsInFilter =
    (getSettingValue({
      name: "EnableViewEachOtherPostByStudents",
      courseId: state.teacher.selected_class.selected_course,
      organizationId: state.login.userInfo.org_id,
      userId: state.login.userInfo.id,
      userEntityType: state.login.userInfo.userEntityType,
    }) ||
      userType == "staff") &&
    userType != "parent";
  const defaultStudentIdentifierNamePreference = getDefaultStudentIdentifierNamePreference(
    state
  );

  const staffAccessPermission = isPortfolioReviewSetupEnabledAndIsJournalRoute()
    ? getSettingValue({
        name: "StaffPermission:PortfolioReviewer",
        organizationId: userInfo?.org_id,
        userId: userInfo?.id,
        currentCurriculumProgramId: getSelectedCurriculumId(state),
      })
    : TEACHER_PERMISSION;

  const isRoutinePost = _.includes(window.location.href, "/routines");

  return {
    childName: _.get(state, "login.userInfo.childName", ""),
    userType: userInfo.user_type,
    showCommentButton,
    // for family portal student's id is stored in "childID"
    // for student portfolio in educator app, the student id is passed from parent component as "portfolioStudentId"
    // for student portal the id of student is stored in "id"
    studentId,
    isOpenedFromStudentPortfolio: !!ownProps?.portfolioStudentId,
    postId: ownProps.item.id,
    organizationId: userInfo?.org_id,
    curriculumProgramType: _.get(
      state,
      "platform.currentCurriculumProgram.type"
    ),
    canCreateComment,
    isArchivedClass,
    isCurrentAcademicYearSelected,
    isRemovedCourseForLoggedInUser,
    filteredStudentActivities: isRoutinePost
      ? filteredStudentRoutines
      : filteredStudentActivities,
    curriculumProgramId: getSelectedCurriculumId(state),
    canUserSeeRateLearningGoals,
    showPostLearningGoals,
    canDownloadMedia,
    isPostApprovalEnabled,
    defaultStudentNameOrderPreference,
    currentChildId:
      userInfo.user_type === "parent" ? userInfo.childID : undefined,
    showAllStudentsInFilter,
    defaultStudentIdentifierNamePreference,
    journalFilters: _.get(state, "journal.filters", null),
    staffAccessPermission,
    filteredStudentRoutines,
    isRoutinePost,
  };
};

const mapActionCreators = {
  markPostAsSeenByUser,
  updatePostStatus,
  getCurrentAssessmentTypes,
  downloadFromUrl,
  removeProgressElement,
};

const getQueryParams = props => {
  return props?.ownProps;
};
export default compose(
  connect(mapStateToProps, mapActionCreators),
  I18nHOC({ resource: ["journal", "common"] }),
  withQueryParamsBasedInterface({ cb: getQueryParams })
)(PostCard);

PostCard.displayName = "PostCard";
